import {
  Svg,
  Rect,
  Path,
  G,
  Defs,
  ClipPath,
  Circle,
  Line,
} from "@react-pdf/renderer";

export function IdeaIcon(fill) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 40 40"
      fill="none"
    >
      <Rect width="40" height="40" rx="8" ry="8" fill="#EBF1FD" />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.3142 11.0025C21.7379 8.53248 17.561 8.53248 14.9848 11.0025C12.4418 13.4407 12.6854 17.1848 15.2758 19.6684C16.0085 20.3709 16.3359 21.3781 16.4928 22.2805C16.6509 23.19 16.6509 24.0913 16.6509 24.6636V24.675C16.6509 24.8619 16.6979 24.9638 16.7376 25.0209C16.7798 25.0816 16.8403 25.1292 16.9191 25.167C17.0002 25.2058 17.0886 25.2282 17.1618 25.2399C17.197 25.2455 17.225 25.2481 17.2418 25.2492C17.2488 25.2497 17.2536 25.2499 17.256 25.25H22.0429C22.0453 25.2499 22.0502 25.2497 22.0571 25.2492C22.074 25.2481 22.102 25.2455 22.1372 25.2399C22.2103 25.2282 22.2987 25.2058 22.3798 25.167C22.4586 25.1292 22.5192 25.0816 22.5614 25.0209C22.601 24.9638 22.648 24.8619 22.648 24.675V24.6636C22.648 24.0913 22.648 23.19 22.8061 22.2805C22.963 21.3781 23.2905 20.3709 24.0231 19.6684C26.705 17.0971 26.8622 13.4456 24.3142 11.0025ZM14.1367 10.1894C17.1813 7.27021 22.1176 7.27021 25.1623 10.1894C28.2351 13.1356 27.9631 17.5172 24.8713 20.4816C24.4045 20.9291 24.1322 21.6469 23.9892 22.4695C23.8485 23.2789 23.8475 24.0967 23.8475 24.675C23.8475 25.0631 23.7446 25.3924 23.5593 25.6588C23.3766 25.9216 23.1373 26.0896 22.9162 26.1955C22.6975 26.3004 22.4861 26.35 22.3343 26.3742C22.2571 26.3866 22.1913 26.393 22.1426 26.3963C22.1181 26.398 22.0976 26.3989 22.0818 26.3994L22.0614 26.3999L22.054 26.4L22.0509 26.4L22.0496 26.4C22.0493 26.4 22.0483 26.4 22.0483 25.825V26.4H17.2506V25.825C17.2506 26.4 17.2509 26.4 17.2506 26.4L17.2494 26.4L17.248 26.4L17.245 26.4L17.2375 26.3999L17.2172 26.3994C17.2013 26.3989 17.1808 26.398 17.1563 26.3963C17.1076 26.393 17.0419 26.3866 16.9646 26.3742C16.8129 26.35 16.6014 26.3004 16.3827 26.1955C16.1616 26.0896 15.9223 25.9216 15.7396 25.6588C15.5544 25.3924 15.4515 25.0631 15.4515 24.675C15.4515 24.0967 15.4504 23.2789 15.3097 22.4695C15.1667 21.6469 14.8945 20.9291 14.4277 20.4816C11.4383 17.6153 11.0588 13.1404 14.1367 10.1894Z"
        fill="#2D70E2"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6681 30.425C16.6681 30.1074 16.9366 29.85 17.2678 29.85H22.0655C22.3967 29.85 22.6652 30.1074 22.6652 30.425C22.6652 30.7426 22.3967 31 22.0655 31H17.2678C16.9366 31 16.6681 30.7426 16.6681 30.425Z"
        fill="#2D70E2"
      />
    </Svg>
  );
}

export function TeamsIcon(fill) {
  return (
    <Svg
      width="25"
      height="25"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Rect width="40" height="40" rx="8" ry="8" fill="#D4F5ED" />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0242 14.0103C10.5314 14.6545 10.233 15.6941 10.233 17.2396C10.233 19.5044 10.8736 20.5703 11.364 21.1855C11.4777 21.3282 11.5855 21.4491 11.6921 21.5688C11.7088 21.5875 11.7254 21.6062 11.7421 21.625C11.8533 21.7502 11.9898 21.9049 12.0895 22.0671C12.1951 22.2387 12.3064 22.4925 12.2676 22.8059C12.23 23.1087 12.0675 23.3392 11.9054 23.5088C11.3726 24.0657 10.7244 24.4659 10.0943 24.7953C9.77793 24.9606 9.45597 25.1132 9.14986 25.2581L9.14425 25.2608C8.83631 25.4066 8.54532 25.5444 8.26996 25.6883C7.70947 25.9813 7.27361 26.2704 6.97683 26.6165C6.69857 26.941 6.52652 27.3337 6.52652 27.8958C6.52652 28.2525 6.24995 28.5417 5.90877 28.5417C5.56759 28.5417 5.29102 28.2525 5.29102 27.8958C5.29102 27.0049 5.58228 26.3077 6.05691 25.7543C6.51302 25.2224 7.11962 24.8455 7.71742 24.533C8.01417 24.3779 8.32361 24.2314 8.62387 24.0892L8.6401 24.0815C8.94933 23.9351 9.24995 23.7925 9.54172 23.64C10.0977 23.3494 10.5852 23.0407 10.9701 22.6582C10.937 22.6181 10.8937 22.5681 10.8367 22.5039C10.8219 22.4872 10.8065 22.4699 10.7904 22.4519C10.6844 22.333 10.5521 22.1846 10.4148 22.0124C9.74693 21.1745 8.99754 19.8186 8.99754 17.2396C8.99754 15.5562 9.31683 14.174 10.0594 13.2035C10.823 12.2054 11.9498 11.75 13.3218 11.75C14.6938 11.75 15.8206 12.2054 16.5842 13.2035C17.3268 14.174 17.6461 15.5562 17.6461 17.2396C17.6461 19.8186 16.8967 21.1745 16.2288 22.0124C16.0915 22.1846 15.9592 22.333 15.8532 22.4519C15.8372 22.4699 15.8217 22.4872 15.8069 22.5039C15.7499 22.5681 15.7066 22.6181 15.6735 22.6582C16.0584 23.0407 16.546 23.3494 17.1019 23.64C17.3937 23.7925 17.6943 23.9351 18.0035 24.0815L18.0198 24.0892C18.32 24.2314 18.6295 24.3779 18.9262 24.533C19.524 24.8455 20.1306 25.2224 20.5867 25.7543C21.0613 26.3077 21.3526 27.0049 21.3526 27.8958C21.3526 28.2525 21.076 28.5417 20.7349 28.5417C20.3937 28.5417 20.1171 28.2525 20.1171 27.8958C20.1171 27.3337 19.9451 26.941 19.6668 26.6165C19.37 26.2704 18.9342 25.9813 18.3737 25.6883C18.0983 25.5444 17.8073 25.4066 17.4994 25.2608L17.4938 25.2581C17.1877 25.1132 16.8657 24.9606 16.5494 24.7953C15.9192 24.4659 15.271 24.0657 14.7383 23.5088C14.5761 23.3392 14.4136 23.1087 14.376 22.8059C14.3372 22.4925 14.4486 22.2387 14.5541 22.0671C14.6538 21.9049 14.7903 21.7502 14.9016 21.625C14.9182 21.6062 14.9349 21.5875 14.9516 21.5688C15.0581 21.4491 15.1659 21.3282 15.2796 21.1855C15.77 20.5703 16.4106 19.5044 16.4106 17.2396C16.4106 15.6941 16.1123 14.6545 15.6194 14.0103C15.1476 13.3937 14.4211 13.0417 13.3218 13.0417C12.2225 13.0417 11.496 13.3937 11.0242 14.0103Z"
        fill="#1D9A7D"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.3793 14.0103C22.8864 14.6545 22.5881 15.6941 22.5881 17.2396C22.5881 19.5044 23.2287 20.5703 23.7191 21.1855C23.8328 21.3282 23.9405 21.4491 24.0471 21.5688C24.0638 21.5875 24.0805 21.6062 24.0971 21.625C24.2084 21.7502 24.3449 21.9049 24.4446 22.0671C24.5501 22.2387 24.6615 22.4925 24.6227 22.8059C24.5851 23.1087 24.4226 23.3392 24.2604 23.5088C23.6708 24.1252 22.9373 24.5514 22.241 24.9021C21.9626 25.0423 21.6957 25.1686 21.4411 25.2892C20.8357 25.5758 20.2998 25.8294 19.8434 26.1583C19.5625 26.3607 19.1778 26.2867 18.9842 25.993C18.7906 25.6993 18.8614 25.2971 19.1423 25.0947C19.6959 24.6959 20.3887 24.3678 21.0347 24.062C21.2671 23.952 21.4933 23.8449 21.7049 23.7383C22.3386 23.4193 22.895 23.0858 23.3252 22.6582C23.2921 22.6181 23.2488 22.5681 23.1918 22.5039C23.177 22.4872 23.1615 22.4699 23.1455 22.4519C23.0395 22.333 22.9072 22.1846 22.7699 22.0124C22.102 21.1745 21.3526 19.8186 21.3526 17.2396C21.3526 15.5562 21.6719 14.174 22.4145 13.2035C23.1781 12.2054 24.3049 11.75 25.6769 11.75C27.0489 11.75 28.1757 12.2054 28.9393 13.2035C29.6819 14.174 30.0012 15.5562 30.0012 17.2396C30.0012 19.8186 29.2518 21.1745 28.5839 22.0124C28.4466 22.1846 28.3143 22.333 28.2083 22.4519C28.1922 22.4699 28.1768 22.4872 28.162 22.5039C28.105 22.5681 28.0617 22.6181 28.0286 22.6582C28.4135 23.0407 28.901 23.3494 29.457 23.64C29.7487 23.7925 30.0494 23.9351 30.3586 24.0815L30.3748 24.0892C30.6751 24.2314 30.9845 24.3779 31.2813 24.533C31.8791 24.8455 32.4857 25.2224 32.9418 25.7543C33.4164 26.3077 33.7077 27.0049 33.7077 27.8958C33.7077 28.2525 33.4311 28.5417 33.0899 28.5417C32.7488 28.5417 32.4722 28.2525 32.4722 27.8958C32.4722 27.3337 32.3001 26.941 32.0219 26.6165C31.7251 26.2704 31.2892 25.9813 30.7287 25.6883C30.4534 25.5444 30.1624 25.4066 29.8544 25.2608L29.8488 25.2581C29.5427 25.1132 29.2208 24.9606 28.9044 24.7953C28.2743 24.4659 27.626 24.0657 27.0933 23.5088C26.9312 23.3392 26.7687 23.1087 26.7311 22.8059C26.6923 22.4925 26.8036 22.2387 26.9092 22.0671C27.0089 21.9049 27.1454 21.7502 27.2566 21.625C27.2733 21.6062 27.2899 21.5875 27.3066 21.5688C27.4132 21.4491 27.521 21.3282 27.6347 21.1855C28.1251 20.5703 28.7657 19.5044 28.7657 17.2396C28.7657 15.6941 28.4673 14.6545 27.9745 14.0103C27.5027 13.3937 26.7762 13.0417 25.6769 13.0417C24.5776 13.0417 23.8511 13.3937 23.3793 14.0103Z"
        fill="#1D9A7D"
      />
    </Svg>
  );
}

export function QuestionButtonIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G id="Icons" clip-path="url(#clip0_2558_35258)">
        <Path
          id="Vector"
          d="M24.8278 37.2415C35.1117 37.2415 43.4485 28.9047 43.4485 18.6207C43.4485 8.33679 35.1117 0 24.8278 0C14.5438 0 6.20703 8.33679 6.20703 18.6207C6.20703 28.9047 14.5438 37.2415 24.8278 37.2415Z"
          fill="#F15062"
        />
        <Path
          id="Vector_2"
          d="M36.1625 20.7131C36.0034 20.6972 35.8455 20.6895 35.6898 20.6895C34.2462 20.6893 32.903 21.3419 31.9971 22.5077C31.3333 23.3617 31.0346 24.4458 31.0346 25.5274V33.0674C31.0346 33.6039 30.6259 34.0648 30.0904 34.0999C29.7187 34.1242 29.3438 34.1378 28.9657 34.1378C18.6818 34.1378 10.3449 25.8011 10.3449 15.517C10.3449 10.359 12.4435 5.69227 15.8319 2.32031C9.59152 5.77184 5.53859 12.6956 6.29831 20.4892C7.04949 28.1943 12.6803 34.701 20.1748 36.6412C24.0573 37.6464 27.745 37.3237 31.0346 36.1583V36.1591C34.8698 34.8013 38.1317 32.2382 40.3449 28.9056V25.4921C40.3449 23.0469 38.5078 20.9477 36.1625 20.7131Z"
          fill="#C84146"
        />
        <G id="Group">
          <Path
            id="Vector_3"
            d="M24.8273 25.6034C24.1131 25.6034 23.5342 25.0245 23.5342 24.3104V23.7224C23.5342 22.5521 24.4041 21.5626 25.5577 21.4211C28.5753 21.0523 30.817 18.4777 30.7746 15.4324C30.7312 12.2976 28.047 9.61283 24.9122 9.56947C23.3099 9.5533 21.7936 10.1554 20.6511 11.2818C19.5085 12.4089 18.8791 13.9131 18.8791 15.5173C18.8791 16.2315 18.3002 16.8104 17.586 16.8104C16.8719 16.8104 16.293 16.2315 16.293 15.5173C16.293 13.2155 17.196 11.0576 18.8346 9.4408C20.4449 7.85279 22.5685 6.98291 24.8263 6.98291C24.8668 6.98291 24.9072 6.98291 24.9486 6.98338C29.5229 7.04701 33.2971 10.8213 33.3609 15.3962C33.4205 19.6811 30.325 23.317 26.1205 23.9545V24.3105C26.1204 25.0245 25.5414 25.6034 24.8273 25.6034Z"
            fill="white"
          />
          <Path
            id="Vector_4"
            d="M24.8271 30.5174C23.9716 30.5174 23.2754 29.8212 23.2754 28.9657C23.2754 28.1103 23.9716 27.4141 24.8271 27.4141C25.6825 27.4141 26.3787 28.1103 26.3787 28.9657C26.3787 29.8212 25.6825 30.5174 24.8271 30.5174Z"
            fill="white"
          />
        </G>
        <Path
          id="Vector_5"
          d="M53.7932 49.6553V42.0441C53.7932 40.6913 52.8197 39.4586 51.4736 39.3238C49.9257 39.1689 48.6208 40.3804 48.6208 41.8967V41.0096C48.6208 39.6568 47.6473 38.4241 46.3012 38.2893C44.7532 38.1344 43.4484 39.3459 43.4484 40.8622V39.9751C43.4484 38.6222 42.4749 37.3895 41.1287 37.2548C39.5808 37.0999 38.2759 38.3113 38.2759 39.8276V25.4924C38.2759 24.1396 37.3025 22.9069 35.9563 22.7722C34.4084 22.6172 33.1035 23.8287 33.1035 25.345V49.6553C33.1035 55.3687 37.735 60.0002 43.4484 60.0002C49.1617 60.0002 53.7932 55.3687 53.7932 49.6553Z"
          fill="#F0C087"
        />
        <G id="Group_2">
          <Path
            id="Vector_6"
            d="M35.1725 49.6557V25.3454C35.1725 24.2895 35.8116 23.3934 36.7185 22.9917C36.4813 22.8822 36.2293 22.8 35.9563 22.7727C34.4084 22.6176 33.1035 23.8291 33.1035 25.3454V49.6557C33.1035 55.3691 37.735 60.0006 43.4484 60.0006C43.7976 60.0006 44.1425 59.982 44.4829 59.9483C39.2553 59.4292 35.1725 55.0197 35.1725 49.6557Z"
            fill="#E6AF78"
          />
          <Path
            id="Vector_7"
            d="M39.3118 41.3796C39.883 41.3796 40.3463 40.9164 40.3463 40.3451V39.8278C40.3463 38.772 40.9854 37.8758 41.8923 37.4741C41.6552 37.3647 41.4031 37.2824 41.1302 37.2551C39.5822 37.1001 38.2773 38.3115 38.2773 39.8278V40.3451C38.2773 40.9165 38.7405 41.3796 39.3118 41.3796Z"
            fill="#E6AF78"
          />
          <Path
            id="Vector_8"
            d="M44.4817 42.4143C45.053 42.4143 45.5162 41.9511 45.5162 41.3798V40.8625C45.5162 39.8066 46.1554 38.9105 47.0623 38.5088C46.8251 38.3993 46.573 38.3171 46.3001 38.2898C44.7521 38.1347 43.4473 39.3462 43.4473 40.8625V41.3798C43.4473 41.9511 43.9104 42.4143 44.4817 42.4143Z"
            fill="#E6AF78"
          />
          <Path
            id="Vector_9"
            d="M49.6555 43.449C50.2268 43.449 50.69 42.9857 50.69 42.4144V41.8972C50.69 40.8413 51.3292 39.9452 52.2361 39.5435C51.9989 39.434 51.7468 39.3517 51.4739 39.3244C49.926 39.1694 48.6211 40.3809 48.6211 41.8972V42.4144C48.6211 42.9857 49.0842 43.449 49.6555 43.449Z"
            fill="#E6AF78"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_2558_35258">
          <Rect width="30" height="30" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function CommunicationIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M51.5857 17.3684L50.6431 11.4106C50.5552 10.8465 50.0268 10.4635 49.4602 10.5505C48.8955 10.6398 48.5106 11.1697 48.6006 11.7339L48.9561 13.9824C44.2604 8.42949 37.3497 5.17285 29.9989 5.17285C21.0937 5.17285 12.8218 9.98457 8.41016 17.7311L10.2084 18.7545C14.2524 11.6534 21.8352 7.2418 29.9989 7.2418C36.7463 7.2418 43.0895 10.2355 47.3939 15.3389L45.2021 14.5807C44.6616 14.3953 44.0736 14.6803 43.8857 15.2206C43.6989 15.7606 43.9857 16.3495 44.5252 16.5365L50.2261 18.508C50.3372 18.5458 50.4513 18.5646 50.5645 18.5646C50.804 18.5646 51.0404 18.4811 51.2293 18.3232C51.5068 18.0897 51.6432 17.727 51.5857 17.3684Z"
        fill="#D5E2F9"
      />
      <Path
        d="M48.7767 42.8638C44.5236 49.0597 37.5044 52.7586 29.9994 52.7586C24.6565 52.7586 19.6246 50.9313 15.5678 47.5858L18.1877 48.0293C18.7513 48.1272 19.2848 47.7455 19.3809 47.1821C19.4758 46.6189 19.097 46.085 18.5333 45.9895L12.586 44.9829C12.2283 44.9198 11.8636 45.0537 11.6273 45.33C11.3909 45.6058 11.3172 45.9856 11.4323 46.3306L13.3426 52.0521C13.487 52.485 13.8901 52.7593 14.3235 52.7593C14.4316 52.7593 14.5427 52.7416 14.6508 52.7058C15.1933 52.5245 15.4853 51.9384 15.3045 51.3965L14.6849 49.5405C19.0341 52.967 24.3601 54.8278 29.9995 54.8278C38.1865 54.8278 45.844 50.7929 50.482 44.0349L48.7767 42.8638Z"
        fill="#D5E2F9"
      />
      <Path
        d="M3.10348 15.5171H34.1379C35.8519 15.5171 37.2414 16.9066 37.2414 18.6206V35.1722C37.2414 36.8862 35.8519 38.2757 34.1379 38.2757H14.4827L8.70176 44.0567C7.78102 44.9774 6.20684 44.3253 6.20684 43.0232V38.2757H3.10348C1.38949 38.2757 0 36.8862 0 35.1722V18.6206C0 16.9065 1.38949 15.5171 3.10348 15.5171Z"
        fill="#D5E2F9"
      />
      <Path
        d="M20.6895 38.276H34.1377C35.8516 38.276 37.2411 36.8865 37.2411 35.1725V19.6553H25.8619C23.0053 19.6553 20.6895 21.9711 20.6895 24.8277V38.276Z"
        fill="#C7CFE2"
      />
      <Path
        d="M8.27668 21.7238H5.1732C4.60145 21.7238 4.13867 21.2606 4.13867 20.6893C4.13867 20.118 4.60133 19.6548 5.1732 19.6548H8.27668C8.84844 19.6548 9.31121 20.118 9.31121 20.6893C9.31121 21.2606 8.84844 21.7238 8.27668 21.7238Z"
        fill="#9FA3AA"
      />
      <Path
        d="M32.0686 21.7238H12.4134C11.8417 21.7238 11.3789 21.2606 11.3789 20.6893C11.3789 20.118 11.8416 19.6548 12.4134 19.6548H32.0686C32.6404 19.6548 33.1031 20.118 33.1031 20.6893C33.1031 21.2606 32.6405 21.7238 32.0686 21.7238Z"
        fill="#B3B3B3"
      />
      <Path
        d="M12.4126 25.862H5.17125C4.59949 25.862 4.13672 25.3988 4.13672 24.8275C4.13672 24.2562 4.59937 23.793 5.17125 23.793H12.4126C12.9844 23.793 13.4471 24.2562 13.4471 24.8275C13.4471 25.3988 12.9844 25.862 12.4126 25.862Z"
        fill="#B3B3B3"
      />
      <Path
        d="M16.5502 23.793C15.9784 23.793 15.5156 24.2562 15.5156 24.8275C15.5156 25.3988 15.9783 25.862 16.5502 25.862H24.8261V23.7931H16.5502V23.793Z"
        fill="#9FA3AA"
      />
      <Path
        d="M18.6196 30.0002H5.17125C4.59949 30.0002 4.13672 29.537 4.13672 28.9657C4.13672 28.3944 4.59937 27.9312 5.17125 27.9312H18.6196C19.1913 27.9312 19.6541 28.3944 19.6541 28.9657C19.6541 29.537 19.1913 30.0002 18.6196 30.0002Z"
        fill="#9FA3AA"
      />
      <Path
        d="M8.27473 34.1379H5.17125C4.59949 34.1379 4.13672 33.6747 4.13672 33.1034C4.13672 32.5321 4.59937 32.0688 5.17125 32.0688H8.27473C8.84648 32.0688 9.30926 32.5321 9.30926 33.1034C9.30926 33.6747 8.84648 34.1379 8.27473 34.1379Z"
        fill="#9FA3AA"
      />
      <Path
        d="M12.4134 32.0688C11.8417 32.0688 11.3789 32.5321 11.3789 33.1034C11.3789 33.6747 11.8416 34.1379 12.4134 34.1379H24.8272V32.069H12.4134V32.0688Z"
        fill="#B3B3B3"
      />
      <Path
        d="M21.75 21.7243H32.0714C32.6432 21.7243 33.1059 21.2611 33.1059 20.6898C33.1059 20.1185 32.6433 19.6553 32.0714 19.6553H25.8646C24.1778 19.6554 22.6942 20.475 21.75 21.7243Z"
        fill="#9FA3AA"
      />
      <Path
        d="M24.8293 32.0688H20.6914V34.1378H24.8293V32.0688Z"
        fill="#9FA3AA"
      />
      <Path
        d="M56.8957 21.7236H25.8613C24.1473 21.7236 22.7578 23.1131 22.7578 24.8271V41.3788C22.7578 43.0928 24.1473 44.4823 25.8613 44.4823H45.5164L51.2974 50.2632C52.2182 51.184 53.7923 50.5318 53.7923 49.2298V44.4823H56.8958C58.6098 44.4823 59.9993 43.0928 59.9993 41.3788V24.8271C59.9992 23.1131 58.6097 21.7236 56.8957 21.7236Z"
        fill="#27CDA7"
      />
      <Path
        d="M45.5602 29.3617L40.1917 35.6231L37.8621 32.5177C37.5186 32.059 36.871 31.9681 36.4144 32.3105C35.9568 32.6529 35.8639 33.3015 36.2073 33.7581L39.3107 37.896C39.4986 38.1475 39.7906 38.299 40.1048 38.3092C40.1159 38.3104 40.1271 38.3104 40.1382 38.3104C40.4392 38.3104 40.7272 38.179 40.9231 37.9487L47.1301 30.7074C47.5028 30.2739 47.4523 29.6214 47.0179 29.2497C46.5855 28.8778 45.9321 28.9263 45.5602 29.3617Z"
        fill="white"
      />
    </Svg>
  );
}

export function EducationExamplesIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G id="Icons" clip-path="url(#clip0_2558_35268)">
        <Path
          id="Vector"
          opacity="0.8"
          d="M30 3.10352C19.6497 3.10352 17.2971 13.498 17.2012 26.4557C17.1972 26.9948 17.514 27.4804 17.9996 27.7073C19.8286 28.5619 23.0786 29.2225 25.6034 29.6151H34.3965C36.9212 29.2225 40.1714 28.5618 42.0003 27.7073C42.4857 27.4805 42.8027 26.9949 42.7987 26.4557C42.7029 13.4979 40.3502 3.10352 30 3.10352Z"
          fill="#694B4B"
        />
        <Path
          id="Vector_2"
          opacity="0.8"
          d="M17.2012 26.4557C17.1972 26.9948 17.514 27.4804 17.9996 27.7073C19.8286 28.5619 23.0786 29.2225 25.6034 29.6151H30V14.4829C30 14.4829 24.8585 14.7338 25.8621 14.4829C30 13.4484 38.2759 8.27594 33.4629 3.56172C32.4219 3.26242 31.2719 3.10352 30.0001 3.10352C19.6497 3.10363 17.2971 13.498 17.2012 26.4557Z"
          fill="#5A4146"
        />
        <Path
          id="Vector_3"
          d="M45.5416 53.793V37.8588C45.5416 36.1884 44.537 34.6816 42.9952 34.0392L35.6964 30.998C35.0151 30.7142 34.5713 30.0483 34.5713 29.3103V27.1011H25.4293V29.3103C25.4293 30.0483 24.9855 30.7141 24.3041 30.998L17.0054 34.0392C15.4633 34.6817 14.459 36.1883 14.459 37.8588V53.793H45.5416Z"
          fill="#D29B6E"
        />
        <Path
          id="Vector_4"
          d="M42.9952 34.0392L37.8643 31.9014C35.9753 34.181 34.1025 35.901 32.472 37.1617H27.5286C25.8981 35.9009 24.0252 34.1809 22.1363 31.9014L17.0054 34.0392C15.4633 34.6816 14.459 36.1883 14.459 37.8588V53.793H45.5417V37.8588C45.5416 36.1883 44.537 34.6816 42.9952 34.0392Z"
          fill="#FFC565"
        />
        <G id="Group">
          <Path
            id="Vector_5"
            d="M15.0528 35.7422C14.6774 36.3705 14.459 37.095 14.459 37.8588V53.793H20.69V41.3793L15.0528 35.7422Z"
            fill="#FFF1D7"
          />
          <Path
            id="Vector_6"
            d="M44.9477 35.7422C45.3231 36.3705 45.5415 37.095 45.5415 37.8588V53.793H39.3105V41.3793L44.9477 35.7422Z"
            fill="#FFF1D7"
          />
        </G>
        <Path
          id="Vector_7"
          d="M39.0741 15.7375L38.4031 23.1176C38.2935 24.3226 37.5951 25.3955 36.5372 25.9831L31.7761 28.6281C30.6716 29.2417 29.3288 29.2417 28.2244 28.6281L23.4633 25.9831C22.4056 25.3955 21.707 24.3226 21.5975 23.1176L20.9496 15.991C20.8994 15.4383 21.2925 14.9464 21.8438 14.882C24.2854 14.597 30.6983 13.7032 34.5796 11.8183C35.0705 11.5798 35.6462 11.7721 35.9184 12.2451C36.3633 13.0184 37.1844 14.1 38.5314 14.7415C38.9041 14.9191 39.1115 15.3264 39.0741 15.7375Z"
          fill="#F0C087"
        />
        <Path
          id="Vector_8"
          d="M58.9655 56.8963H1.03453C0.463242 56.8963 0 56.4331 0 55.8618V53.7928C0 53.2215 0.463242 52.7583 1.03453 52.7583H58.9656C59.5369 52.7583 60.0001 53.2215 60.0001 53.7928V55.8618C60 56.4332 59.5368 56.8963 58.9655 56.8963Z"
          fill="#F5DCB4"
        />
        <Path
          id="Vector_9"
          d="M20.9496 15.9911L21.5975 23.1177C21.707 24.3228 22.4055 25.3955 23.4633 25.9832L28.2244 28.6282C28.6602 28.8703 29.1357 28.9889 29.6164 29.0398L28.2766 25.6906C28.0477 25.1182 27.9053 24.5152 27.8541 23.9009L27.2846 17.0676C27.241 16.544 27.5956 16.0758 28.1099 15.9691C30.3139 15.512 32.6717 14.8906 34.6335 14.0634C35.2805 14.9578 36.2494 15.9463 37.6418 16.6095C37.921 16.7424 38.0535 16.803 38.9703 16.8782L39.074 15.7373C39.1115 15.3243 38.9004 14.9176 38.5262 14.7389C37.1822 14.0972 36.3626 13.0173 35.9184 12.2451C35.6462 11.7721 35.0704 11.5798 34.5795 11.8183C30.6982 13.7034 24.2855 14.597 21.8437 14.882C21.2926 14.9465 20.8994 15.4383 20.9496 15.9911Z"
          fill="#E6AF78"
        />
        <Path
          id="Vector_10"
          d="M20.5431 33.2214C22.3095 35.353 24.2339 37.2294 26.2628 38.7984L26.8218 39.2307H27.5284H32.4718H33.1785L33.7375 38.7984C35.7664 37.2295 37.6909 35.3531 39.4571 33.2214L39.8613 32.7336L37.864 31.9014C35.975 34.181 34.1023 35.901 32.4717 37.1617H27.5283C25.8979 35.9009 24.025 34.1809 22.136 31.9014L20.1387 32.7336L20.5431 33.2214Z"
          fill="#FF8090"
        />
        <Path
          id="Vector_11"
          d="M39.3107 52.7587H20.69C19.5473 52.7587 18.6211 51.8325 18.6211 50.6898V38.276C18.6211 37.1333 19.5473 36.207 20.69 36.207H39.3108C40.4535 36.207 41.3797 37.1333 41.3797 38.276V50.6898C41.3796 51.8325 40.4534 52.7587 39.3107 52.7587Z"
          fill="#D5E2F9"
        />
        <Path
          id="Vector_12"
          d="M30.0006 46.552C31.1432 46.552 32.0695 45.6257 32.0695 44.483C32.0695 43.3404 31.1432 42.4141 30.0006 42.4141C28.8579 42.4141 27.9316 43.3404 27.9316 44.483C27.9316 45.6257 28.8579 46.552 30.0006 46.552Z"
          fill="white"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2558_35268">
          <Rect width="30" height="30" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function SchedulingIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M46.1781 3.53454L44.1546 2.31966C43.6636 2.02516 43.0293 2.18477 42.7351 2.67427C42.4412 3.16423 42.5998 3.79962 43.0897 4.09376L43.2476 4.18845L41.8652 6.49165L43.6392 7.55641L45.0213 5.25356L45.1133 5.30864C45.28 5.4086 45.4638 5.45618 45.6446 5.45618C45.9962 5.45618 46.3386 5.27735 46.5326 4.95403C46.8265 4.46407 46.668 3.82856 46.1781 3.53454Z"
        fill="#959CB5"
      />
      <Path
        d="M38.2773 6.20695C36.566 6.20695 35.1738 4.81477 35.1738 3.10348C35.1738 1.39219 36.566 0 38.2773 0C39.9886 0 41.3808 1.39219 41.3808 3.10348C41.3808 4.81477 39.9886 6.20695 38.2773 6.20695ZM38.2773 2.06895C37.7065 2.06895 37.2428 2.53312 37.2428 3.10348C37.2428 3.67383 37.7065 4.13801 38.2773 4.13801C38.8481 4.13801 39.3118 3.67383 39.3118 3.10348C39.3118 2.53312 38.848 2.06895 38.2773 2.06895Z"
        fill="#959CB5"
      />
      <Path
        d="M7.24215 51.7243H52.7594C54.4734 51.7243 55.8629 50.3348 55.8629 48.6208V17.5864C55.8629 15.8724 54.4734 14.4829 52.7594 14.4829H7.24215C5.52816 14.4829 4.13867 15.8724 4.13867 17.5864V48.6209C4.13867 50.3349 5.52816 51.7243 7.24215 51.7243Z"
        fill="#7F8499"
      />
      <Path
        d="M38.2778 25.8622C44.5626 25.8622 49.6571 20.7674 49.6571 14.4829H26.8984C26.8984 20.7674 31.9932 25.8622 38.2778 25.8622Z"
        fill="#707487"
      />
      <Path
        d="M29.6476 42.4691C29.4225 42.4327 29.1939 42.414 28.9678 42.414C28.5376 42.414 28.1228 42.48 27.7324 42.6023C27.1398 41.9978 26.3711 41.5748 25.5097 41.4347C25.2847 41.3981 25.0561 41.3796 24.8302 41.3796C24.4043 41.3796 23.9885 41.4434 23.5934 41.5666C23.0007 40.9628 22.2326 40.5403 21.372 40.4003C21.147 40.3637 20.9183 40.3452 20.6924 40.3452H20.692V33.2143C20.692 31.1445 19.2054 29.3416 17.2338 29.0209C17.0088 28.9843 16.7802 28.9658 16.5543 28.9658H16.554C15.4487 28.9658 14.4095 29.3961 13.628 30.1778C12.8464 30.9593 12.416 31.9984 12.416 33.1038V51.7246H33.1057V46.6628C33.1058 44.5927 31.6191 42.79 29.6476 42.4691Z"
        fill="#707487"
      />
      <Path
        d="M51.7249 48.621H8.27672C7.70543 48.621 7.24219 48.1577 7.24219 47.5864V18.621C7.24219 18.0497 7.70543 17.5864 8.27672 17.5864H51.725C52.2963 17.5864 52.7596 18.0497 52.7596 18.621V47.5864C52.7595 48.1577 52.2962 48.621 51.7249 48.621Z"
        fill="white"
      />
      <Path
        d="M27.3379 17.5864C28.6902 22.3605 33.0705 25.8623 38.2777 25.8623C43.4849 25.8623 47.8654 22.3606 49.2176 17.5864H27.3379Z"
        fill="#D5E2F9"
      />
      <Path
        d="M16.5527 39.3104C19.9807 39.3104 22.7596 36.5314 22.7596 33.1034C22.7596 29.6754 19.9807 26.8965 16.5527 26.8965C13.1247 26.8965 10.3457 29.6754 10.3457 33.1034C10.3457 36.5314 13.1247 39.3104 16.5527 39.3104Z"
        fill="#2D70E2"
      />
      <Path
        d="M16.552 28.9653C14.2667 28.9653 12.4141 30.8179 12.4141 33.1032V37.7203C13.5127 38.7056 14.96 39.3102 16.552 39.3102C18.1439 39.3102 19.5911 38.7056 20.6898 37.7204V33.1032C20.69 30.8181 18.8373 28.9653 16.552 28.9653Z"
        fill="#3768BB"
      />
      <Path
        d="M38.2752 23.793C43.4171 23.793 47.5855 19.6246 47.5855 14.4827C47.5855 9.34073 43.4171 5.17236 38.2752 5.17236C33.1332 5.17236 28.9648 9.34073 28.9648 14.4827C28.9648 19.6246 33.1332 23.793 38.2752 23.793Z"
        fill="#AFB9D2"
      />
      <Path
        d="M38.2765 21.7239C42.2758 21.7239 45.5179 18.4819 45.5179 14.4826C45.5179 10.4833 42.2758 7.24121 38.2765 7.24121C34.2772 7.24121 31.0352 10.4833 31.0352 14.4826C31.0352 18.4819 34.2772 21.7239 38.2765 21.7239Z"
        fill="#EBF1FD"
      />
      <Path
        d="M38.2763 15.5173C38.0115 15.5173 37.7468 15.4163 37.5449 15.2143L33.9241 11.5935C33.5201 11.1895 33.5201 10.5347 33.9241 10.1307C34.3282 9.72662 34.9829 9.72662 35.387 10.1307L39.0077 13.7514C39.4118 14.1555 39.4118 14.8102 39.0077 15.2143C38.8056 15.4163 38.5409 15.5173 38.2763 15.5173Z"
        fill="#F15062"
      />
      <Path
        d="M38.2748 10.3443C37.703 10.3443 37.2402 9.88107 37.2402 9.30978V8.27525C37.2402 7.70397 37.7029 7.24072 38.2748 7.24072C38.8465 7.24072 39.3093 7.70397 39.3093 8.27525V9.30978C39.3092 9.88107 38.8465 10.3443 38.2748 10.3443Z"
        fill="#707487"
      />
      <Path
        d="M38.2748 21.7237C37.703 21.7237 37.2402 21.2605 37.2402 20.6892V19.6546C37.2402 19.0834 37.7029 18.6201 38.2748 18.6201C38.8465 18.6201 39.3093 19.0834 39.3093 19.6546V20.6892C39.3092 21.2606 38.8465 21.7237 38.2748 21.7237Z"
        fill="#707487"
      />
      <Path
        d="M44.4812 15.5168H43.4466C42.8749 15.5168 42.4121 15.0536 42.4121 14.4823C42.4121 13.911 42.8748 13.4478 43.4466 13.4478H44.4812C45.0529 13.4478 45.5157 13.911 45.5157 14.4823C45.5157 15.0536 45.053 15.5168 44.4812 15.5168Z"
        fill="#707487"
      />
      <Path
        d="M33.1023 15.5168H32.0677C31.496 15.5168 31.0332 15.0536 31.0332 14.4823C31.0332 13.911 31.4959 13.4478 32.0677 13.4478H33.1023C33.674 13.4478 34.1368 13.911 34.1368 14.4823C34.1367 15.0536 33.674 15.5168 33.1023 15.5168Z"
        fill="#707487"
      />
      <Path
        d="M30.0005 38.276C32.8572 38.276 35.173 35.9602 35.173 33.1036C35.173 30.2469 32.8572 27.9312 30.0005 27.9312C27.1439 27.9312 24.8281 30.2469 24.8281 33.1036C24.8281 35.9602 27.1439 38.276 30.0005 38.276Z"
        fill="#56EDCA"
      />
      <Path
        d="M43.4478 38.276C46.3045 38.276 48.6202 35.9602 48.6202 33.1036C48.6202 30.2469 46.3045 27.9312 43.4478 27.9312C40.5912 27.9312 38.2754 30.2469 38.2754 33.1036C38.2754 35.9602 40.5912 38.276 43.4478 38.276Z"
        fill="#56EDCA"
      />
      <Path
        d="M30 36.207C31.714 36.207 33.1034 34.8175 33.1034 33.1035C33.1034 31.3895 31.714 30 30 30C28.286 30 26.8965 31.3895 26.8965 33.1035C26.8965 34.8175 28.286 36.207 30 36.207Z"
        fill="#27CDA7"
      />
      <Path
        d="M43.4492 36.207C45.1632 36.207 46.5527 34.8175 46.5527 33.1035C46.5527 31.3895 45.1632 30 43.4492 30C41.7352 30 40.3457 31.3895 40.3457 33.1035C40.3457 34.8175 41.7352 36.207 43.4492 36.207Z"
        fill="#27CDA7"
      />
      <Path
        d="M15.9677 36.276C15.7146 36.276 15.4615 36.1794 15.2683 35.9861L13.2898 34.0076C12.9034 33.6215 12.9034 32.9949 13.2898 32.6088C13.6763 32.2223 14.3022 32.2223 14.6887 32.6088L15.9677 33.8879L18.5658 31.2898C18.9522 30.9034 19.5781 30.9034 19.9646 31.2898C20.3511 31.676 20.3511 32.3026 19.9646 32.6887L16.6672 35.9861C16.474 36.1794 16.2209 36.276 15.9677 36.276Z"
        fill="white"
      />
    </Svg>
  );
}

export function QuestionsIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clip-path="url(#clip0_2558_35823)">
        <Path
          d="M57.9311 60.0003H2.06895C0.92625 60.0003 0 59.0741 0 57.9314V39.3106C0 38.1679 0.92625 37.2417 2.06895 37.2417H57.9311C59.0737 37.2417 60 38.1679 60 39.3106V57.9314C60 59.0741 59.0737 60.0003 57.9311 60.0003Z"
          fill="#EBF1FD"
        />
        <Path
          d="M50.6943 43.4485H32.0736C31.5018 43.4485 31.0391 42.9852 31.0391 42.4139C31.0391 41.8426 31.5017 41.3794 32.0736 41.3794H50.6943C51.2661 41.3794 51.7289 41.8426 51.7289 42.4139C51.7289 42.9852 51.2661 43.4485 50.6943 43.4485Z"
          fill="#9FA3AA"
        />
        <Path
          d="M54.8322 51.7238H32.0736C31.5018 51.7238 31.0391 51.2606 31.0391 50.6893C31.0391 50.118 31.5017 49.6548 32.0736 49.6548H54.8322C55.404 49.6548 55.8668 50.118 55.8668 50.6893C55.8668 51.2606 55.4041 51.7238 54.8322 51.7238Z"
          fill="#9FA3AA"
        />
        <Path
          d="M54.8322 55.8606H32.0736C31.5018 55.8606 31.0391 55.3979 31.0391 54.826C31.0391 54.2543 31.5017 53.7915 32.0736 53.7915H54.8322C55.404 53.7915 55.8668 54.2542 55.8668 54.826C55.8668 55.3979 55.4041 55.8606 54.8322 55.8606Z"
          fill="#B3B3B3"
        />
        <Path
          d="M36.2115 47.5852H32.0736C31.5018 47.5852 31.0391 47.1219 31.0391 46.5506C31.0391 45.9794 31.5017 45.5161 32.0736 45.5161H36.2115C36.7832 45.5161 37.246 45.9794 37.246 46.5506C37.2459 47.1219 36.7832 47.5852 36.2115 47.5852Z"
          fill="#B3B3B3"
        />
        <Path
          d="M54.8317 47.5852H40.349C39.7772 47.5852 39.3145 47.1219 39.3145 46.5506C39.3145 45.9794 39.7771 45.5161 40.349 45.5161H54.8317C55.4035 45.5161 55.8663 45.9794 55.8663 46.5506C55.8663 47.1219 55.4036 47.5852 54.8317 47.5852Z"
          fill="#B3B3B3"
        />
        <Path
          d="M57.9311 26.8958H2.06895C0.92625 26.8958 0 25.9696 0 24.8269V6.20627C0 5.06346 0.92625 4.13721 2.06895 4.13721H57.9311C59.0737 4.13721 60 5.06346 60 6.20615V24.8269C60 25.9696 59.0737 26.8958 57.9311 26.8958Z"
          fill="#EBF1FD"
        />
        <Path
          d="M24.823 24.8279H6.20234C3.91707 24.8279 2.06445 22.9753 2.06445 20.69V4.13818H28.961V20.6899C28.9609 22.9753 27.1082 24.8279 24.823 24.8279Z"
          fill="#D5E2F9"
        />
        <Path
          d="M24.823 57.9324H6.20234C3.91707 57.9324 2.06445 56.0797 2.06445 53.7945V37.2427H28.961V53.7944C28.9609 56.0797 27.1082 57.9324 24.823 57.9324Z"
          fill="#D5E2F9"
        />
        <Path
          d="M50.6943 10.3449H32.0736C31.5018 10.3449 31.0391 9.8817 31.0391 9.31041C31.0391 8.73912 31.5017 8.27588 32.0736 8.27588H50.6943C51.2661 8.27588 51.7289 8.73912 51.7289 9.31041C51.7288 9.8817 51.2661 10.3449 50.6943 10.3449Z"
          fill="#9FA3AA"
        />
        <Path
          d="M54.8322 18.6203H32.0736C31.5018 18.6203 31.0391 18.1571 31.0391 17.5858C31.0391 17.0145 31.5017 16.5513 32.0736 16.5513H54.8322C55.404 16.5513 55.8668 17.0145 55.8668 17.5858C55.8668 18.1571 55.4041 18.6203 54.8322 18.6203Z"
          fill="#9FA3AA"
        />
        <Path
          d="M54.8322 22.7571H32.0736C31.5018 22.7571 31.0391 22.2944 31.0391 21.7225C31.0391 21.1508 31.5017 20.688 32.0736 20.688H54.8322C55.404 20.688 55.8668 21.1506 55.8668 21.7225C55.8668 22.2944 55.4041 22.7571 54.8322 22.7571Z"
          fill="#B3B3B3"
        />
        <Path
          d="M36.2115 14.4817H32.0736C31.5018 14.4817 31.0391 14.0184 31.0391 13.4471C31.0391 12.8758 31.5017 12.4126 32.0736 12.4126H36.2115C36.7832 12.4126 37.246 12.8758 37.246 13.4471C37.2459 14.0185 36.7832 14.4817 36.2115 14.4817Z"
          fill="#B3B3B3"
        />
        <Path
          d="M54.8317 14.4817H40.349C39.7772 14.4817 39.3145 14.0184 39.3145 13.4471C39.3145 12.8758 39.7771 12.4126 40.349 12.4126H54.8317C55.4035 12.4126 55.8663 12.8758 55.8663 13.4471C55.8663 14.0185 55.4036 14.4817 54.8317 14.4817Z"
          fill="#B3B3B3"
        />
        <Path
          d="M16.5533 21.7246H14.4844V34.1384H16.5533V21.7246Z"
          fill="#DFDFDF"
        />
        <Path
          d="M16.5533 21.7246H14.4844V24.8281H16.5533V21.7246Z"
          fill="#959CB5"
        />
        <Path
          d="M24.8243 22.7586H6.20371C5.06102 22.7586 4.13477 21.8324 4.13477 20.6897V2.06895C4.13465 0.92625 5.0609 0 6.20371 0H24.8245C25.9671 0 26.8934 0.92625 26.8934 2.06895V20.6897C26.8933 21.8324 25.967 22.7586 24.8243 22.7586Z"
          fill="#F15062"
        />
        <Path
          d="M21.9837 10.3444C21.9837 6.7793 19.0833 3.87891 15.5182 3.87891C11.9531 3.87891 9.05273 6.7793 9.05273 10.3444V12.4133C9.05273 15.9784 11.9531 18.8788 15.5182 18.8788C16.8341 18.8788 18.0579 18.4815 19.0802 17.8038L19.7764 18.5C20.029 18.7526 20.3593 18.8789 20.6906 18.8789C21.0219 18.8789 21.3523 18.7526 21.6048 18.5C22.1099 17.995 22.1099 17.1766 21.6048 16.6714L20.9086 15.9752C21.5864 14.9529 21.9837 13.7291 21.9837 12.4132V10.3444ZM18.5013 13.5681C17.9963 13.063 17.1779 13.063 16.6727 13.5681C16.1675 14.0732 16.1677 14.8915 16.6727 15.3967L17.18 15.904C16.6743 16.146 16.1152 16.2927 15.5181 16.2927C13.3794 16.2927 11.6388 14.5526 11.6388 12.4134V10.3444C11.6388 8.20523 13.3795 6.46512 15.5181 6.46512C17.6566 6.46512 19.3973 8.20523 19.3973 10.3444V12.4133C19.3973 13.0104 19.2506 13.5696 19.0086 14.0754L18.5013 13.5681Z"
          fill="white"
        />
        <Path
          d="M24.8243 55.8631H6.20371C5.06102 55.8631 4.13477 54.9369 4.13477 53.7942V35.1734C4.13477 34.0307 5.06102 33.1045 6.20371 33.1045H24.8245C25.9671 33.1045 26.8934 34.0307 26.8934 35.1734V53.7942C26.8933 54.9369 25.967 55.8631 24.8243 55.8631Z"
          fill="#27CDA7"
        />
        <Path
          d="M21.942 50.3761L19.1324 39.1362C18.8144 37.8685 17.6797 36.9824 16.3725 36.9824H14.6571C13.3499 36.9824 12.2154 37.8685 11.8971 39.1373L9.08755 50.3761C8.91482 51.0682 9.33611 51.7702 10.029 51.944C10.719 52.1178 11.4231 51.6965 11.5969 51.0025L12.128 48.8789H18.9017L19.4325 51.0025C19.5801 51.5904 20.1063 51.9824 20.6862 51.9824C20.7903 51.9824 20.8953 51.9702 21.0004 51.944C21.6935 51.7702 22.1148 51.0682 21.942 50.3761ZM12.7747 46.2927L14.4068 39.7647C14.4352 39.6495 14.5382 39.5686 14.6574 39.5686H16.3727C16.4919 39.5686 16.5951 39.6495 16.6233 39.7636L18.2552 46.2927H12.7747Z"
          fill="white"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2558_35823">
          <Rect width="30" height="30" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function StructuredSectionsIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clip-path="url(#clip0_2558_35911)">
        <Path
          d="M38.4584 44.1016L29.3917 41.3119C28.5234 41.0448 27.9312 40.2428 27.9312 39.3345V33.6211H13.4483V39.3345C13.4483 40.2428 12.8559 41.0448 11.9879 41.3119L2.92113 44.1016C1.18477 44.6359 0 46.2401 0 48.0566V52.2418C0 53.3844 0.926367 54.3108 2.06895 54.3108H39.3103C40.4529 54.3108 41.3793 53.3844 41.3793 52.2418V48.0566C41.3793 46.2401 40.1946 44.6359 38.4584 44.1016Z"
          fill="#D29B6E"
        />
        <Path
          d="M38.4584 44.1009L30.8783 41.7686C29.0175 45.5189 25.16 48.1032 20.6897 48.1032C16.2193 48.1032 12.3619 45.519 10.5011 41.7687L2.92102 44.1011C1.18477 44.6352 0 46.2394 0 48.0559V52.2411C0 53.3837 0.926367 54.3101 2.06895 54.3101H39.3103C40.4529 54.3101 41.3793 53.3837 41.3793 52.2411V48.0559C41.3793 46.2394 40.1946 44.6352 38.4584 44.1009Z"
          fill="#EBF1FD"
        />
        <Path
          d="M20.6905 5.68945C13.2632 5.68945 7.24219 11.7104 7.24219 19.1378V23.2757H34.1387V19.1378C34.1387 11.7103 28.1179 5.68945 20.6905 5.68945Z"
          fill="#666D79"
        />
        <Path
          d="M11.3832 22.2412H8.27988C7.13731 22.2412 6.21094 23.1675 6.21094 24.3102V29.4826C6.21094 30.6252 7.13731 31.5515 8.27988 31.5515H11.3834L11.3832 22.2412Z"
          fill="#D5E2F9"
        />
        <Path
          d="M30.0059 31.5515H33.1093C34.2519 31.5515 35.1783 30.6253 35.1783 29.4826V24.3102C35.1783 23.1676 34.2519 22.2412 33.1093 22.2412H30.0059V31.5515Z"
          fill="#D5E2F9"
        />
        <Path
          d="M24.6574 38.0735L28.8094 34.6136C29.5779 33.9733 30.0882 33.0762 30.2463 32.0885L32.0146 21.0378C33.1294 14.0703 27.7472 7.7583 20.691 7.7583C13.6348 7.7583 8.25256 14.0703 9.36737 21.0378L11.1356 32.0885C11.2936 33.0762 11.8042 33.9733 12.5726 34.6136L16.7245 38.0735C17.2822 38.5383 17.9853 38.7928 18.7112 38.7928H22.671C23.3966 38.7928 24.0997 38.5384 24.6574 38.0735Z"
          fill="#F0C087"
        />
        <Path
          d="M20.6908 38.7932H19.9766C19.7146 38.7932 19.4611 38.5387 19.2599 38.0739L17.7621 34.6141C17.4848 33.9738 17.3007 33.0767 17.2437 32.089L16.6058 21.0383C16.2037 14.0725 18.1445 7.76244 20.6889 7.75928C13.6336 7.76057 8.25268 14.0717 9.36737 21.0384L11.1354 32.0893C11.2933 33.0769 11.8039 33.974 12.5723 34.6143L16.7243 38.0742C17.282 38.5389 17.9851 38.7935 18.711 38.7935H20.691L20.6908 38.7932Z"
          fill="#E6AF78"
        />
        <Path
          d="M56.897 25.3452H42.4143C40.7003 25.3452 39.3108 26.7347 39.3108 28.4487V31.5522L35.2862 35.5767C34.8626 36.0004 35.1626 36.7246 35.7616 36.7246H39.3107V37.7591C39.3107 39.4731 40.7002 40.8626 42.4141 40.8626H56.8969C58.6109 40.8626 60.0003 39.4731 60.0003 37.7591V28.4488C60.0005 26.7346 58.611 25.3452 56.897 25.3452Z"
          fill="#B3B3B3"
        />
        <Path
          d="M52.86 31.4561H43.1397C42.8412 31.4561 42.5996 31.2142 42.5996 30.916C42.5996 30.6178 42.8411 30.376 43.1397 30.376H52.86C53.1585 30.376 53.4001 30.6178 53.4001 30.916C53.4001 31.2142 53.1585 31.4561 52.86 31.4561Z"
          fill="#DFDFDF"
        />
        <Path
          d="M55.0201 35.7759H43.1397C42.8412 35.7759 42.5996 35.5341 42.5996 35.2358C42.5996 34.9376 42.8411 34.6958 43.1397 34.6958H55.0201C55.3186 34.6958 55.5601 34.9376 55.5601 35.2358C55.5601 35.5341 55.3186 35.7759 55.0201 35.7759Z"
          fill="#DFDFDF"
        />
        <Path
          d="M20.691 7.7583C13.6348 7.7583 8.25256 14.0703 9.36737 21.0375L9.89096 24.31C11.1629 24.31 12.4145 24.31 12.4145 24.31L13.3441 17.725C13.4112 17.325 13.7038 16.993 14.0958 16.8892C18.4017 15.749 22.9806 15.749 27.2865 16.8892C27.6786 16.993 27.9711 17.325 28.0382 17.725L28.9674 24.31H31.491L32.0146 21.0375C33.1292 14.0701 27.7472 7.7583 20.691 7.7583Z"
          fill="#694B4B"
        />
        <Path
          d="M9.36737 21.0375L9.89096 24.31C11.1629 24.31 12.4147 24.31 12.4145 24.31L13.3441 17.725C13.4112 17.325 13.7038 16.993 14.0958 16.8892C14.9499 16.6629 15.817 16.4945 16.6884 16.3581C17.1442 11.4816 18.7366 7.76076 20.689 7.7583C13.6336 7.75971 8.25268 14.0708 9.36737 21.0375Z"
          fill="#5A4146"
        />
        <Path
          d="M31.3246 25.3445L31.6557 23.2755H25.2605C25.0907 23.2755 24.9241 23.3175 24.7735 23.3971L23.4652 24.0948C21.966 23.0415 19.3536 23.0537 17.8746 24.1241L16.2058 23.3679C16.0715 23.3067 15.9259 23.2754 15.7784 23.2754H9.72461L10.0557 25.3443H15.5552L17.6331 26.2864C17.7706 26.349 17.916 26.3789 18.0605 26.3789C18.3544 26.3789 18.6434 26.253 18.8445 26.0188C19.1121 25.7076 19.7557 25.3445 20.6902 25.3445C21.6246 25.3445 22.2681 25.7077 22.5359 26.0188C22.8501 26.386 23.3794 26.4849 23.8068 26.2572L25.5193 25.3445H31.3246Z"
          fill="#D5E2F9"
        />
        <Path
          d="M16.5511 27.9312C17.9794 27.9312 19.1373 26.7733 19.1373 25.345C19.1373 23.9167 17.9794 22.7588 16.5511 22.7588C15.1227 22.7588 13.9648 23.9167 13.9648 25.345C13.9648 26.7733 15.1227 27.9312 16.5511 27.9312Z"
          fill="#EBF1FD"
        />
        <Path
          d="M24.8264 27.9312C26.2548 27.9312 27.4127 26.7733 27.4127 25.345C27.4127 23.9167 26.2548 22.7588 24.8264 22.7588C23.3981 22.7588 22.2402 23.9167 22.2402 25.345C22.2402 26.7733 23.3981 27.9312 24.8264 27.9312Z"
          fill="#EBF1FD"
        />
        <Path
          d="M6.12469 49.2413L1.20469 45.1411C0.452578 45.8988 0 46.9357 0 48.0555V52.2407C0 53.3833 0.926367 54.3096 2.06895 54.3096H7.24137V51.6253C7.24137 50.7042 6.83227 49.8307 6.12469 49.2413Z"
          fill="#D5E2F9"
        />
        <Path
          d="M35.2516 49.2421L40.1716 45.1421C40.9237 45.8996 41.3762 46.9366 41.3762 48.0563V52.2415C41.3762 53.3841 40.4499 54.3105 39.3073 54.3105H34.1348V51.6262C34.1348 50.7051 34.544 49.8316 35.2516 49.2421Z"
          fill="#D5E2F9"
        />
        <Path
          d="M8.50195 42.3833C10.6403 46.9788 15.2859 50.1721 20.6886 50.1721C26.0913 50.1721 30.7371 46.9788 32.8753 42.3833L30.8773 41.7686C29.0164 45.5188 25.159 48.1031 20.6886 48.1031C16.2183 48.1031 12.3608 45.5189 10.5 41.7686L8.50195 42.3833Z"
          fill="#D5E2F9"
        />
        <Path
          d="M45.6014 33.6746H43.2016C42.87 33.6746 42.6016 33.4059 42.6016 33.0746C42.6016 32.7433 42.8699 32.4746 43.2016 32.4746H45.6014C45.933 32.4746 46.2014 32.7433 46.2014 33.0746C46.2014 33.4059 45.933 33.6746 45.6014 33.6746Z"
          fill="#DFDFDF"
        />
        <Path
          d="M56.3981 33.6746H47.9984C47.6668 33.6746 47.3984 33.4059 47.3984 33.0746C47.3984 32.7433 47.6668 32.4746 47.9984 32.4746H56.3981C56.7297 32.4746 56.9981 32.7433 56.9981 33.0746C56.9981 33.4059 56.7297 33.6746 56.3981 33.6746Z"
          fill="#DFDFDF"
        />
      </G>
      <Defs>
        <clipPath id="clip0_2558_35911">
          <Rect width="30" height="30" fill="white" />
        </clipPath>
      </Defs>
    </Svg>
  );
}

export function FollowUpIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M55.8684 29.0254H4.13005C3.5469 29.0254 3.07422 28.3777 3.07422 27.579V10.2218C3.07422 9.42291 3.54702 8.77539 4.13005 8.77539H55.8684C56.4515 8.77539 56.9242 9.42307 56.9242 10.2218V27.579C56.9243 28.3779 56.4515 29.0254 55.8684 29.0254Z"
        fill="#EBF1FD"
      />
      <Path
        d="M15.7435 29.0254H4.12994C3.54685 29.0254 3.07422 28.3777 3.07422 27.579V10.2218C3.07422 9.42291 3.54697 8.77539 4.12994 8.77539H15.7435C16.3266 8.77539 16.7992 9.42307 16.7992 10.2218V27.579C16.7993 28.3779 16.3266 29.0254 15.7435 29.0254Z"
        fill="#2D70E2"
      />
      <Path
        d="M39.0381 17.8624H21.0816C20.4978 17.8624 20.0254 17.39 20.0254 16.8062C20.0254 16.2224 20.4978 15.75 21.0816 15.75H39.038C39.6218 15.75 40.0942 16.2224 40.0942 16.8062C40.0943 17.39 39.6219 17.8624 39.0381 17.8624Z"
        fill="#9FA3AA"
      />
      <Path
        d="M27.4192 22.088H21.0816C20.4978 22.088 20.0254 21.6156 20.0254 21.0318C20.0254 20.448 20.4978 19.9756 21.0816 19.9756H27.4192C28.003 19.9756 28.4754 20.448 28.4754 21.0318C28.4754 21.6155 28.003 22.088 27.4192 22.088Z"
        fill="#B3B3B3"
      />
      <Path
        d="M55.8684 51.1498H4.13005C3.54702 51.1498 3.07422 50.5069 3.07422 49.7141V32.4855C3.07422 31.6925 3.54702 31.0498 4.13005 31.0498H55.8684C56.4515 31.0498 56.9242 31.6927 56.9242 32.4855V49.7141C56.9243 50.5069 56.4515 51.1498 55.8684 51.1498Z"
        fill="#EBF1FD"
      />
      <Path
        d="M15.7435 51.1498H4.12994C3.54697 51.1498 3.07422 50.5069 3.07422 49.7141V32.4855C3.07422 31.6925 3.54697 31.0498 4.12994 31.0498H15.7435C16.3266 31.0498 16.7992 31.6927 16.7992 32.4855V49.7141C16.7993 50.5069 16.3266 51.1498 15.7435 51.1498Z"
        fill="#27CDA7"
      />
      <Path
        d="M39.0381 40.5118H21.0816C20.4978 40.5118 20.0254 40.0395 20.0254 39.4556C20.0254 38.8718 20.4978 38.3994 21.0816 38.3994H39.038C39.6218 38.3994 40.0942 38.8718 40.0942 39.4556C40.0942 40.0395 39.6219 40.5118 39.0381 40.5118Z"
        fill="#9FA3AA"
      />
      <Path
        d="M27.4192 44.7374H21.0816C20.4978 44.7374 20.0254 44.265 20.0254 43.6812C20.0254 43.0974 20.4978 42.625 21.0816 42.625H27.4192C28.003 42.625 28.4754 43.0974 28.4754 43.6812C28.4754 44.265 28.003 44.7374 27.4192 44.7374Z"
        fill="#B3B3B3"
      />
      <Path
        d="M49.5985 22.087H31.6421C31.0588 22.087 30.5859 21.6141 30.5859 21.0308C30.5859 20.4475 31.0589 19.9746 31.6421 19.9746H49.5985C50.1819 19.9746 50.6547 20.4476 50.6547 21.0308C50.6547 21.6141 50.1819 22.087 49.5985 22.087Z"
        fill="#B3B3B3"
      />
      <Path
        d="M49.5985 44.7364H31.6421C31.0588 44.7364 30.5859 44.2635 30.5859 43.6802C30.5859 43.0969 31.0589 42.624 31.6421 42.624H49.5985C50.1819 42.624 50.6547 43.097 50.6547 43.6802C50.6547 44.2636 50.1819 44.7364 49.5985 44.7364Z"
        fill="#B3B3B3"
      />
      <Path
        d="M12.4647 21.2759V22.8748H7.67921V21.2759H9.24478V16.668C9.17816 16.7569 9.07453 16.8568 8.93388 16.9678C8.80064 17.0715 8.6452 17.1751 8.46754 17.2787C8.28989 17.3749 8.10853 17.4564 7.92348 17.523C7.73842 17.5896 7.57187 17.6229 7.42383 17.6229V15.9907C7.62369 15.9907 7.82725 15.9389 8.03451 15.8353C8.24918 15.7316 8.44534 15.6132 8.62299 15.48C8.80064 15.3393 8.94499 15.2135 9.05602 15.1025C9.16705 14.9914 9.22997 14.9322 9.24478 14.9248H11.0546V21.2759H12.4647Z"
        fill="white"
      />
      <Path
        d="M7.05078 45.075C7.05078 44.6173 7.07293 44.2187 7.11722 43.8792C7.16151 43.5396 7.2427 43.237 7.36081 42.9712C7.47891 42.7055 7.63762 42.4693 7.83692 42.2626C8.04361 42.0485 8.30566 41.8455 8.62307 41.6536C8.86666 41.506 9.11763 41.3657 9.37599 41.2329C9.64173 41.0926 9.88901 40.9487 10.1178 40.801C10.3467 40.646 10.5312 40.4726 10.6715 40.2806C10.8191 40.0813 10.8929 39.8525 10.8929 39.5942C10.8929 39.3948 10.8523 39.2325 10.7711 39.107C10.6973 38.9741 10.5866 38.8744 10.4389 38.808C10.2987 38.7342 10.1326 38.6973 9.94068 38.6973C9.70447 38.6973 9.47564 38.7453 9.25419 38.8412C9.03275 38.9298 8.82975 39.0405 8.64521 39.1734C8.46067 39.2989 8.30196 39.4318 8.1691 39.572L7.06185 38.3983C7.18734 38.2581 7.34974 38.1141 7.54904 37.9665C7.74834 37.8189 7.98086 37.6823 8.2466 37.5568C8.51234 37.424 8.80761 37.3206 9.1324 37.2468C9.45719 37.1656 9.80781 37.125 10.1843 37.125C10.7674 37.125 11.262 37.2247 11.668 37.424C12.074 37.6159 12.3803 37.889 12.587 38.2433C12.8011 38.5976 12.9081 39.011 12.9081 39.4834C12.9081 39.7935 12.8638 40.074 12.7752 40.3249C12.6866 40.5685 12.5612 40.79 12.3988 40.9893C12.2364 41.1812 12.0481 41.3584 11.8341 41.5208C11.62 41.6831 11.3912 41.8382 11.1476 41.9858C10.8154 42.1703 10.5423 42.3327 10.3282 42.473C10.1142 42.6132 9.93699 42.7387 9.79674 42.8494C9.66387 42.9602 9.55684 43.0672 9.47564 43.1705C9.39444 43.2739 9.32063 43.3772 9.25419 43.4806H12.9192V45.075H7.05078Z"
        fill="white"
      />
    </Svg>
  );
}

export function ActionPlanEllipse(fill) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="5"
      viewBox="0 0 11 11"
      fill="none"
    >
      <Circle cx="5.5" cy="5.5" r="5" fill="#D5E2F9" stroke="#D5E2F9" />
    </Svg>
  );
}

export function ActionPlanDottedLine({ height, color, width }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 1 783"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Line
        x1="0.5"
        y1="2.18556e-08"
        x2="0.499966"
        y2={height}
        stroke={color}
        stroke-dasharray="2 2"
      />
    </Svg>
  );
}

export function ContextSessionsIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M37.2419 48.1035H22.7591L21.7246 57.4138H38.2764L37.2419 48.1035Z"
        fill="#5B5D6E"
      />
      <Path
        d="M37.5866 51.207L37.2417 48.1035H22.7589L22.4141 51.207H37.5866Z"
        fill="#666D79"
      />
      <Path
        d="M57.9311 49.138H2.06895C0.92625 49.138 0 48.2118 0 47.0691V9.82773C0 8.68504 0.92625 7.75879 2.06895 7.75879H57.9311C59.0737 7.75879 60 8.68504 60 9.82773V47.0691C60 48.2118 59.0737 49.138 57.9311 49.138Z"
        fill="#707487"
      />
      <Path
        d="M22.8398 7.75879C23.343 11.2667 26.352 13.9657 29.9989 13.9657C33.6459 13.9657 36.655 11.2668 37.158 7.75879H22.8398Z"
        fill="#5B5D6E"
      />
      <Path
        d="M55.8623 46.0348H4.13805C3.56676 46.0348 3.10352 45.5716 3.10352 45.0003V11.8968C3.10352 11.3255 3.56676 10.8623 4.13805 10.8623H55.8623C56.4336 10.8623 56.8968 11.3255 56.8968 11.8968V45.0003C56.8967 45.5716 56.4336 46.0348 55.8623 46.0348Z"
        fill="#E4EAF8"
      />
      <Path
        d="M56.8973 28.4485H34.1387V10.8623H55.8629C56.4342 10.8623 56.8974 11.3255 56.8974 11.8968V28.4485H56.8973Z"
        fill="#D4F5ED"
      />
      <Path
        d="M56.8973 28.4482H34.1387V46.0345H55.8629C56.4342 46.0345 56.8974 45.5712 56.8974 44.9999V28.4482H56.8973Z"
        fill="#D5E2F9"
      />
      <Path
        d="M34.138 46.0348H4.13805C3.56676 46.0348 3.10352 45.5716 3.10352 45.0003V11.8968C3.10352 11.3255 3.56676 10.8623 4.13805 10.8623H34.138V46.0348Z"
        fill="#FFEDCF"
      />
      <Path
        d="M40.3453 58.4489H19.6556C19.0839 58.4489 18.6211 57.9863 18.6211 57.4144C18.6211 56.8425 19.0838 56.3799 19.6556 56.3799H40.3453C40.9171 56.3799 41.3798 56.8425 41.3798 57.4144C41.3798 57.9863 40.9171 58.4489 40.3453 58.4489Z"
        fill="#707487"
      />
      <Path
        d="M27.9314 46.0342V43.3875C27.9314 42.497 27.3615 41.7063 26.5167 41.4247L23.1393 40.2989C22.2945 40.0173 21.7246 39.2266 21.7246 38.3361V35.6895H15.5176V38.3361C15.5176 39.2266 14.9477 40.0173 14.1029 40.2989L10.7255 41.4247C9.88043 41.7063 9.31055 42.497 9.31055 43.3875V46.0342H27.9314Z"
        fill="#D29B6E"
      />
      <Path
        d="M26.5167 41.4251L23.1393 40.2991C22.9364 40.2315 22.7516 40.1314 22.5845 40.0107C21.6356 41.1534 20.2222 41.8966 18.621 41.8966C17.0197 41.8966 15.6063 41.1534 14.6576 40.0107C14.4905 40.1314 14.3058 40.2316 14.1028 40.2991L10.7254 41.4251C9.88043 41.7067 9.31055 42.4973 9.31055 43.3879V46.0345H27.9313V43.3879C27.9314 42.4973 27.3615 41.7067 26.5167 41.4251Z"
        fill="#959CB5"
      />
      <Path
        d="M18.6203 23.2766C20.9056 23.2766 22.7582 21.6556 22.7582 19.6559C22.7582 17.6562 20.9056 16.0352 18.6203 16.0352C16.335 16.0352 14.4824 17.6562 14.4824 19.6559C14.4824 21.6556 16.335 23.2766 18.6203 23.2766Z"
        fill="#694B4B"
      />
      <Path
        d="M18.6196 34.6559C23.1903 34.6559 26.8955 31.1823 26.8955 26.8973C26.8955 22.6123 23.1903 19.1387 18.6196 19.1387C14.049 19.1387 10.3438 22.6123 10.3438 26.8973C10.3438 31.1823 14.049 34.6559 18.6196 34.6559Z"
        fill="#694B4B"
      />
      <Path
        d="M20.6213 19.3752C19.9798 19.2257 19.3124 19.1377 18.6216 19.1377C14.0511 19.1377 10.3457 22.6114 10.3457 26.8963C10.3457 30.5758 13.0806 33.6501 16.7466 34.4474C16.7466 33.1161 16.7466 31.1352 16.7466 28.1895C16.7467 23.7081 18.9045 20.9038 20.6213 19.3752Z"
        fill="#5A4146"
      />
      <Path
        d="M23.8379 35.1503L20.472 36.8332C19.307 37.4157 17.9358 37.4157 16.7708 36.8332L13.4048 35.1503C12.7861 34.841 12.3631 34.2428 12.2772 33.5564L11.6488 28.5299C11.5747 27.9374 12.013 27.4085 12.6088 27.3696C14.537 27.2434 18.5581 26.7594 21.0372 24.9032C21.4552 24.5902 22.0388 24.6453 22.3961 25.0262L25.2721 28.0935C25.4824 28.3178 25.582 28.6242 25.5438 28.9294L24.9654 33.5564C24.8798 34.2429 24.4567 34.841 23.8379 35.1503Z"
        fill="#F0C087"
      />
      <Path
        d="M25.2721 28.0932L22.396 25.0259C22.3006 24.924 22.1871 24.8494 22.0668 24.7949C22.0273 24.7771 21.9845 24.7734 21.9433 24.7607C21.8598 24.7352 21.7757 24.7123 21.689 24.7086C21.615 24.7055 21.5414 24.715 21.468 24.7283C21.4307 24.7349 21.3929 24.7353 21.3563 24.7461C21.2446 24.7796 21.1359 24.829 21.0375 24.9028C18.5541 26.7621 14.5232 27.2445 12.599 27.3699C11.9998 27.4089 11.5746 27.9338 11.6491 28.5296L12.2775 33.556C12.3634 34.2425 12.7864 34.8406 13.4052 35.15L16.7711 36.8329C17.2737 37.0842 17.8163 37.2053 18.3625 37.2399L17.0989 34.7125C16.7398 33.9942 16.5528 33.2022 16.5528 32.3991V29.7349C16.5528 29.2533 16.8867 28.8446 17.3539 28.7278C18.7706 28.3736 20.2278 27.8555 21.4932 27.0875L23.7632 29.5086C24.0986 29.8664 24.573 30.2736 25.3811 30.2347L25.5444 28.929C25.5821 28.6238 25.4824 28.3175 25.2721 28.0932Z"
        fill="#E6AF78"
      />
      <Path
        d="M48.6216 41.3799H42.4146C41.272 41.3799 40.3457 42.3061 40.3457 43.4488V46.035H50.6905V43.4488C50.6905 42.3061 49.7643 41.3799 48.6216 41.3799Z"
        fill="#FFDC64"
      />
      <Path
        d="M45.5185 42.9305C44.6615 42.9305 43.9668 42.2357 43.9668 41.3788V39.8271H47.0703V41.3788C47.0702 42.2357 46.3754 42.9305 45.5185 42.9305Z"
        fill="#D29B6E"
      />
      <Path
        d="M45.695 40.8618H45.34C44.7913 40.8618 44.265 40.6439 43.877 40.2559L43.02 39.3989C42.632 39.0109 42.4141 38.4847 42.4141 37.9359V34.6549C42.4141 33.5122 43.3403 32.5859 44.483 32.5859H46.552C47.6946 32.5859 48.6209 33.5122 48.6209 34.6549V37.9359C48.6209 38.4846 48.4029 39.0109 48.0149 39.3989L47.1579 40.2559C46.7699 40.6438 46.2436 40.8618 45.695 40.8618Z"
        fill="#F0C087"
      />
      <Path
        d="M46.552 32.5859H44.483C43.3403 32.5859 42.4141 33.5122 42.4141 34.6549V35.6894C42.4141 35.6894 45.5175 35.6894 48.621 34.6549C48.621 33.5122 47.6948 32.5859 46.552 32.5859Z"
        fill="#694B4B"
      />
      <Path
        d="M48.6216 23.793H42.4146C41.272 23.793 40.3457 24.7192 40.3457 25.8619V28.4481H50.6905V25.862C50.6905 24.7192 49.7643 23.793 48.6216 23.793Z"
        fill="#707487"
      />
      <Path
        d="M45.5185 25.3446C44.6615 25.3446 43.9668 24.6498 43.9668 23.7929V22.2412H47.0703V23.7929C47.0702 24.6498 46.3754 25.3446 45.5185 25.3446Z"
        fill="#D29B6E"
      />
      <Path
        d="M45.695 23.2759H45.34C44.7913 23.2759 44.265 23.0579 43.877 22.6699L43.02 21.8129C42.632 21.4249 42.4141 20.8987 42.4141 20.35V17.0689C42.4141 15.9262 43.3403 15 44.483 15H46.552C47.6946 15 48.6209 15.9262 48.6209 17.0689V20.35C48.6209 20.8986 48.4029 21.4249 48.0149 21.8129L47.1579 22.6699C46.7699 23.0578 46.2436 23.2759 45.695 23.2759Z"
        fill="#F0C087"
      />
      <Path
        d="M46.552 15H44.483C43.3403 15 42.4141 15.9262 42.4141 17.0689V18.1035C42.4141 18.1035 45.5175 18.1035 48.621 17.0689C48.621 15.9262 47.6948 15 46.552 15Z"
        fill="#694B4B"
      />
      <Path
        d="M30.0001 13.9657C31.5414 13.9657 32.9657 13.4796 34.138 12.6582V10.8623H24.0703C25.3767 12.7364 27.5415 13.9657 30.0001 13.9657Z"
        fill="#FFE6B0"
      />
      <Path
        d="M34.1387 12.6583C34.8364 12.1694 35.4432 11.5617 35.9305 10.8623H34.1387V12.6583Z"
        fill="#8CE9BA"
      />
      <Path
        d="M30.0005 11.8966C32.8572 11.8966 35.173 9.58083 35.173 6.72418C35.173 3.86753 32.8572 1.55176 30.0005 1.55176C27.1439 1.55176 24.8281 3.86753 24.8281 6.72418C24.8281 9.58083 27.1439 11.8966 30.0005 11.8966Z"
        fill="#959CB5"
      />
      <Path
        d="M30.0006 8.79316C31.1432 8.79316 32.0695 7.86687 32.0695 6.72422C32.0695 5.58157 31.1432 4.65527 30.0006 4.65527C28.8579 4.65527 27.9316 5.58157 27.9316 6.72422C27.9316 7.86687 28.8579 8.79316 30.0006 8.79316Z"
        fill="#666D79"
      />
    </Svg>
  );
}

export function KeyChangesIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M8.27539 2.06895C8.27539 0.92625 9.20164 0 10.3443 0H41.3789L51.7237 10.3448V57.9311C51.7237 59.0737 50.7975 60 49.6548 60H10.3443C9.20164 60 8.27539 59.0737 8.27539 57.9311V2.06895Z"
        fill="#EBF1FD"
      />
      <Path
        d="M41.3789 0V8.2759C41.3789 9.41848 42.3053 10.3448 43.4479 10.3448H51.7238L41.3789 0Z"
        fill="#AFBAD6"
      />
      <Path
        d="M44.4821 32.0693H29.9994C29.4276 32.0693 28.9648 32.532 28.9648 33.1039C28.9648 33.6757 29.4275 34.1384 29.9994 34.1384H44.4821C45.0539 34.1384 45.5166 33.6757 45.5166 33.1039C45.5166 32.532 45.054 32.0693 44.4821 32.0693Z"
        fill="#9FA3AA"
      />
      <Path
        d="M29.9994 38.2761H38.2753C38.847 38.2761 39.3098 37.8134 39.3098 37.2416C39.3098 36.6698 38.8471 36.207 38.2753 36.207H29.9994C29.4276 36.207 28.9648 36.6697 28.9648 37.2416C28.9648 37.8134 29.4276 38.2761 29.9994 38.2761Z"
        fill="#B3B3B3"
      />
      <Path
        d="M24.0407 30.3617L18.6722 36.6231L16.3425 33.5177C15.9991 33.059 15.3515 32.9681 14.8949 33.3105C14.4373 33.6529 14.3444 34.3015 14.6877 34.7581L17.7912 38.896C17.9791 39.1475 18.2711 39.299 18.5853 39.3092C18.5964 39.3104 18.6075 39.3104 18.6187 39.3104C18.9197 39.3104 19.2076 39.179 19.4036 38.9487L25.6105 31.7074C25.9833 31.2739 25.9328 30.6214 25.4984 30.2497C25.066 29.8778 24.4125 29.9263 24.0407 30.3617Z"
        fill="#27CDA7"
      />
      <Path
        d="M44.4821 44.4824H29.9994C29.4276 44.4824 28.9648 44.9451 28.9648 45.517C28.9648 46.0888 29.4275 46.5515 29.9994 46.5515H44.4821C45.0539 46.5515 45.5166 46.0888 45.5166 45.517C45.5166 44.9451 45.054 44.4824 44.4821 44.4824Z"
        fill="#9FA3AA"
      />
      <Path
        d="M38.2753 48.6201H29.9994C29.4276 48.6201 28.9648 49.0828 28.9648 49.6546C28.9648 50.2264 29.4275 50.6892 29.9994 50.6892H38.2753C38.847 50.6892 39.3098 50.2265 39.3098 49.6546C39.3097 49.0828 38.847 48.6201 38.2753 48.6201Z"
        fill="#B3B3B3"
      />
      <Path
        d="M24.0407 42.7754L18.6722 49.0369L16.3425 45.9314C15.9991 45.4727 15.3515 45.3808 14.8949 45.7242C14.4373 46.0666 14.3444 46.7153 14.6877 47.1718L17.7912 51.3097C17.9791 51.5612 18.2711 51.7127 18.5853 51.7229C18.5964 51.7241 18.6075 51.7241 18.6187 51.7241C18.9197 51.7241 19.2076 51.5927 19.4036 51.3624L25.6105 44.1211C25.9833 43.6876 25.9328 43.0351 25.4984 42.6634C25.066 42.2915 24.4125 42.3411 24.0407 42.7754Z"
        fill="#27CDA7"
      />
      <Path
        d="M25.8618 9.31055H15.517C14.9452 9.31055 14.4824 9.7732 14.4824 10.3451C14.4824 10.9168 14.9451 11.3796 15.517 11.3796H25.8618C26.4336 11.3796 26.8963 10.917 26.8963 10.3451C26.8962 9.7732 26.4336 9.31055 25.8618 9.31055Z"
        fill="#9FA3AA"
      />
      <Path
        d="M15.517 15.5163H21.7239C22.2957 15.5163 22.7584 15.0537 22.7584 14.4818C22.7584 13.91 22.2958 13.4473 21.7239 13.4473H15.517C14.9452 13.4473 14.4824 13.9099 14.4824 14.4818C14.4824 15.0537 14.9451 15.5163 15.517 15.5163Z"
        fill="#B3B3B3"
      />
    </Svg>
  );
}

export function ComprehensiveIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M39.6147 32.8012L45.3047 38.4912L46.7675 37.0284L41.0775 31.3384L39.6147 32.8012Z"
        fill="#464655"
      />
      <Path
        d="M31.0355 37.2409C39.0341 37.2409 45.5183 30.7568 45.5183 22.7582C45.5183 14.7595 39.0341 8.27539 31.0355 8.27539C23.0369 8.27539 16.5527 14.7595 16.5527 22.7582C16.5527 30.7568 23.0369 37.2409 31.0355 37.2409Z"
        fill="#959CB5"
      />
      <Path
        d="M31.0355 34.1375C37.3201 34.1375 42.4148 29.0428 42.4148 22.7582C42.4148 16.4736 37.3201 11.3789 31.0355 11.3789C24.7509 11.3789 19.6562 16.4736 19.6562 22.7582C19.6562 29.0428 24.7509 34.1375 31.0355 34.1375Z"
        fill="#BAEFFF"
      />
      <Path
        d="M14.4828 15.5173H1.03453C0.462774 15.5173 0 15.0541 0 14.4828C0 13.9115 0.462657 13.4482 1.03453 13.4482H14.4829C15.0546 13.4482 15.5174 13.9115 15.5174 14.4828C15.5173 15.0541 15.0546 15.5173 14.4828 15.5173Z"
        fill="#B3B3B3"
      />
      <Path
        d="M3.10348 19.656H1.03453C0.462774 19.656 0 19.1927 0 18.6214C0 18.0502 0.462657 17.5869 1.03453 17.5869H3.10348C3.67524 17.5869 4.13802 18.0502 4.13802 18.6214C4.1379 19.1929 3.67524 19.656 3.10348 19.656Z"
        fill="#B3B3B3"
      />
      <Path
        d="M13.4485 19.655H7.24156C6.66981 19.655 6.20703 19.1918 6.20703 18.6205C6.20703 18.0492 6.66969 17.5859 7.24156 17.5859H13.4485C14.0203 17.5859 14.4831 18.0492 14.4831 18.6205C14.4829 19.1919 14.0203 19.655 13.4485 19.655Z"
        fill="#9FA3AA"
      />
      <Path
        d="M12.4138 23.7927H1.03453C0.462774 23.7927 0 23.3295 0 22.7582C0 22.1869 0.462657 21.7236 1.03453 21.7236H12.4138C12.9856 21.7236 13.4483 22.1869 13.4483 22.7582C13.4483 23.3296 12.9856 23.7927 12.4138 23.7927Z"
        fill="#B3B3B3"
      />
      <Path
        d="M7.24138 27.9314H1.03453C0.462774 27.9314 0 27.4681 0 26.8968C0 26.3255 0.462657 25.8623 1.03453 25.8623H7.2415C7.81326 25.8623 8.27603 26.3255 8.27603 26.8968C8.27603 27.4681 7.81326 27.9314 7.24138 27.9314Z"
        fill="#9FA3AA"
      />
      <Path
        d="M13.4493 27.9314H11.3802C10.8085 27.9314 10.3457 27.4681 10.3457 26.8968C10.3457 26.3255 10.8084 25.8623 11.3802 25.8623H13.4492C14.0209 25.8623 14.4837 26.3255 14.4837 26.8968C14.4837 27.4681 14.0211 27.9314 13.4493 27.9314Z"
        fill="#B3B3B3"
      />
      <Path
        d="M14.4829 32.0691H7.24156C6.66981 32.0691 6.20703 31.6058 6.20703 31.0345C6.20703 30.4632 6.66969 30 7.24156 30H14.4829C15.0547 30 15.5175 30.4632 15.5175 31.0345C15.5175 31.6058 15.0548 32.0691 14.4829 32.0691Z"
        fill="#9FA3AA"
      />
      <Path
        d="M3.10348 32.0691H1.03453C0.462774 32.0691 0 31.6058 0 31.0345C0 30.4632 0.462657 30 1.03453 30H3.10348C3.67524 30 4.13802 30.4632 4.13802 31.0345C4.13802 31.6058 3.67524 32.0691 3.10348 32.0691Z"
        fill="#B3B3B3"
      />
      <Path
        d="M37.5927 29.3521C37.2573 29.6851 36.6818 29.4371 36.7084 28.9652C36.718 28.7941 36.7232 28.6217 36.7232 28.448C36.7232 22.1634 31.6284 17.0688 25.3439 17.0688C25.1702 17.0688 24.9978 17.0739 24.8267 17.0835C24.3549 17.1099 24.1071 16.5345 24.44 16.1992C26.1988 14.4275 28.6604 13.3564 31.3771 13.4544C36.2226 13.6294 40.1621 17.5686 40.3378 22.4143C40.436 25.1309 39.3648 27.5931 37.5927 29.3521Z"
        fill="#D4F5FF"
      />
      <Path
        d="M55.0053 51.1183L44.4829 40.5959C43.675 39.788 43.675 38.478 44.4829 37.67L45.9454 36.2075C46.7533 35.3996 48.0633 35.3996 48.8713 36.2075L59.3937 46.7299C60.2016 47.5378 60.2016 48.8478 59.3937 49.6558L57.9312 51.1183C57.1233 51.9262 55.8134 51.9262 55.0053 51.1183Z"
        fill="#707487"
      />
      <Path
        d="M56.7715 49.3524L46.2491 38.83C45.4932 38.074 45.4541 36.8839 46.1126 36.0713C46.0567 36.1166 45.9974 36.1558 45.9454 36.2078L44.4829 37.6703C43.675 38.4783 43.675 39.7883 44.4829 40.5963L55.0053 51.1187C55.8133 51.9267 57.1232 51.9267 57.9312 51.1187L59.3937 49.6562C59.4458 49.6041 59.485 49.545 59.5302 49.4891C58.7178 50.1475 57.5275 50.1083 56.7715 49.3524Z"
        fill="#5B5D6E"
      />
    </Svg>
  );
}

export function OpenDiscussionIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M37.3804 43.4121V45.3453C37.3804 45.9914 36.9918 46.5741 36.3953 46.8224L28.6958 50.0272C28.233 50.2199 27.9316 50.6719 27.9316 51.1731C27.9316 51.8585 28.4873 52.4143 29.1729 52.4143H53.587C54.2725 52.4143 54.8283 51.8586 54.8283 51.1731C54.8283 50.6719 54.5269 50.2198 54.0641 50.0272L46.3642 46.8221C45.768 46.5739 45.3796 45.9918 45.3796 45.3459V43.4122"
        fill="#EBF1FD"
      />
      <Path
        d="M41.38 22.4141C32.2971 22.4141 30.2325 31.5357 30.1485 42.9068C30.145 43.38 30.423 43.8059 30.849 44.0052C32.454 44.7552 34.434 45.3349 36.6494 45.6793H46.1102C48.3258 45.3348 50.3057 44.7552 51.9108 44.0052C52.3369 43.8061 52.6148 43.38 52.6113 42.9068C52.5274 31.5357 50.4629 22.4141 41.38 22.4141Z"
        fill="#694B4B"
      />
      <Path
        d="M30.1485 42.9068C30.145 43.38 30.423 43.8059 30.849 44.0052C32.454 44.7552 34.434 45.3349 36.6494 45.6793H41.3798V32.4C41.3798 32.4 36.8679 32.6202 37.7485 32.4C41.3798 31.4922 48.6423 26.9532 44.4186 22.8161C43.505 22.5534 42.496 22.4141 41.3798 22.4141C32.2971 22.4141 30.2325 31.5357 30.1485 42.9068Z"
        fill="#5A4146"
      />
      <Path
        d="M40.595 49.3099H42.1655C44.017 49.3099 45.5181 47.8088 45.5181 45.9571C45.4372 45.7648 45.3797 45.5619 45.3797 45.3448V43.4111H37.3806V45.3441C37.3806 45.5612 37.323 45.7643 37.2422 45.9567V45.9569C37.2423 47.8088 38.7434 49.3099 40.595 49.3099Z"
        fill="#D29B6E"
      />
      <Path
        d="M49.3411 33.5006L48.7523 39.9771C48.6562 41.0346 48.0432 41.9761 47.1148 42.4918L42.9366 44.813C41.9675 45.3515 40.7889 45.3515 39.8197 44.813L35.6415 42.4918C34.7132 41.9761 34.1002 41.0346 34.004 39.9771L33.4354 33.7232C33.3914 33.2381 33.7364 32.8065 34.2201 32.7502C36.3628 32.5001 41.9903 31.7159 45.3964 30.0615C45.8272 29.8523 46.3325 30.0211 46.5713 30.4361C46.9617 31.1147 47.6824 32.0639 48.8643 32.6269C49.1918 32.7824 49.3739 33.1398 49.3411 33.5006Z"
        fill="#F0C087"
      />
      <Path
        d="M33.4374 33.7236L34.006 39.9777C34.1021 41.0352 34.7151 41.9766 35.6433 42.4923L39.8215 44.8134C40.2039 45.0259 40.6212 45.1298 41.043 45.1746L39.5643 41.4778L38.9969 34.6682C38.9586 34.2087 39.2697 33.7978 39.7213 33.7042C41.6554 33.303 43.7247 32.7579 45.4461 32.0319C46.0137 32.8168 46.864 33.6844 48.0859 34.2662C48.331 34.3828 48.4472 34.4359 49.2517 34.5021L49.3428 33.5009C49.3757 33.1384 49.1905 32.7817 48.8621 32.6248C47.6826 32.0616 46.9634 31.1139 46.5734 30.4362C46.3346 30.0211 45.8293 29.8523 45.3985 30.0615C41.9925 31.7157 36.3648 32.5001 34.2222 32.7502C33.7383 32.8069 33.3933 33.2386 33.4374 33.7236Z"
        fill="#E6AF78"
      />
      <Path
        d="M26.2736 32.9707L23.4466 28.259V17.6988C23.4466 15.7547 21.8705 14.1787 19.9264 14.1787H5.84628C3.9022 14.1787 2.32617 15.7547 2.32617 17.6988V35.2992C2.32617 37.2433 3.9022 38.8193 5.84628 38.8193H19.9266C21.8707 38.8193 23.4467 37.2433 23.4467 35.2992V34.1258H25.6198C26.2125 34.1258 26.5787 33.479 26.2736 32.9707Z"
        fill="#DFDFDF"
      />
      <Path
        d="M18.7531 24.7379C18.7531 21.0846 15.4141 18.2113 11.6213 19.0034C9.32687 19.4825 7.50587 21.3883 7.10897 23.6987C6.69612 26.1023 7.74885 28.2922 9.51734 29.5342C10.1329 29.9666 10.5396 30.635 10.5396 31.3875V31.778C10.5396 32.426 11.0651 32.9514 11.713 32.9514H14.0597C14.7077 32.9514 15.2331 32.426 15.2331 31.778V31.381C15.2331 30.6446 15.6161 29.9765 16.2215 29.5577C17.7502 28.4999 18.7531 26.7377 18.7531 24.7379Z"
        fill="#27CDA7"
      />
      <Path
        d="M12.8617 26.9256C12.2192 26.9256 11.6992 26.2883 11.6992 25.5005V22.6506C11.6992 21.863 12.2191 21.2256 12.8617 21.2256C13.5042 21.2256 14.0242 21.8629 14.0242 22.6506V25.5005C14.0242 26.2883 13.5043 26.9256 12.8617 26.9256Z"
        fill="white"
      />
      <Path
        d="M12.8959 30.257C12.2474 30.257 11.7168 29.7322 11.7168 29.0836C11.7168 28.4349 12.2358 27.9102 12.8845 27.9102H12.8959C13.5444 27.9102 14.0693 28.4349 14.0693 29.0836C14.0693 29.7322 13.5446 30.257 12.8959 30.257Z"
        fill="white"
      />
      <Path
        d="M46.3629 46.8216C45.7884 46.5825 45.4155 46.0308 45.3886 45.4132C44.4406 46.5886 43.0028 47.3528 41.3788 47.3528C39.7547 47.3528 38.3171 46.5886 37.369 45.4131C37.3418 46.0309 36.9689 46.5824 36.3941 46.8218L35.9805 46.9941C37.307 48.4814 39.2339 49.4218 41.3788 49.4218C43.5237 49.4218 45.4504 48.4813 46.7772 46.9941L46.3629 46.8216Z"
        fill="#D5E2F9"
      />
    </Svg>
  );
}


export function DateIcon(fill) {
  return (
    <Svg
      width="8"
      height="8"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.78947 0C4.02201 0 4.21053 0.188512 4.21053 0.421053V1.68421H11.7895V0.421053C11.7895 0.188512 11.978 0 12.2105 0C12.4431 0 12.6316 0.188512 12.6316 0.421053V1.68421H13.8947C15.0574 1.68421 16 2.62677 16 3.78947V13.8947C16 15.0574 15.0574 16 13.8947 16H2.10526C0.942558 16 0 15.0574 0 13.8947V3.78947C0 2.62677 0.942558 1.68421 2.10526 1.68421H3.36842V0.421053C3.36842 0.188512 3.55693 0 3.78947 0ZM2.10526 2.52632C1.40764 2.52632 0.842105 3.09185 0.842105 3.78947V5.05263H15.1579V3.78947C15.1579 3.09185 14.5924 2.52632 13.8947 2.52632H2.10526ZM15.1579 5.89474H0.842105V13.8947C0.842105 14.5924 1.40764 15.1579 2.10526 15.1579H13.8947C14.5924 15.1579 15.1579 14.5924 15.1579 13.8947V5.89474Z"
        fill="white"
      />
    </Svg>
  );
}

export function ActionIdeaIcon(fill) {
  return (
    <Svg
      width="30"
      height="30"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clip-path="url(#clip0_2417_32169)">
        <Path
          d="M24.8278 54.8276C24.8278 55.9703 25.7541 56.8966 26.8968 56.8966H33.1037C34.2464 56.8966 35.1727 55.9703 35.1727 54.8276V47.5535C35.1727 45.978 36.0579 44.5187 37.4833 43.8474C43.4534 41.0362 47.5865 34.9673 47.5865 27.9311C47.5865 17.5584 38.6062 9.28307 27.996 10.456C20.0269 11.337 13.5453 17.7171 12.5549 25.6733C11.5635 33.6376 15.9036 40.718 22.4871 43.8332C23.922 44.5121 24.828 45.965 24.828 47.5523V54.8276H24.8278Z"
          fill="#FFC565"
        />
        <Path
          d="M30.0003 42.4137C37.9989 42.4137 44.483 35.9296 44.483 27.931C44.483 19.9324 37.9989 13.4482 30.0003 13.4482C22.0017 13.4482 15.5176 19.9324 15.5176 27.931C15.5176 35.9296 22.0017 42.4137 30.0003 42.4137Z"
          fill="#FFF1D7"
        />
        <Path
          d="M30.0004 39.3103C36.2849 39.3103 41.3796 34.2156 41.3796 27.931C41.3796 21.6464 36.2849 16.5518 30.0004 16.5518C23.7158 16.5518 18.6211 21.6464 18.6211 27.931C18.6211 34.2156 23.7158 39.3103 30.0004 39.3103Z"
          fill="white"
        />
        <Path
          d="M26.8965 55.8623V57.9312C26.8965 59.0738 27.8229 60.0002 28.9654 60.0002H31.0344C32.177 60.0002 33.1033 59.0738 33.1033 57.9312V55.8623H26.8965Z"
          fill="#DFDFDF"
        />
        <Path
          d="M56.8964 28.9653H51.724C51.1522 28.9653 50.6895 28.5021 50.6895 27.9308C50.6895 27.3595 51.1521 26.8962 51.724 26.8962H56.8964C57.4682 26.8962 57.9309 27.3595 57.9309 27.9308C57.9309 28.5022 57.4683 28.9653 56.8964 28.9653Z"
          fill="#FFC565"
        />
        <Path
          d="M9.30973 28.9653H3.10289C2.53113 28.9653 2.06836 28.5021 2.06836 27.9308C2.06836 27.3595 2.53102 26.8962 3.10289 26.8962H9.30984C9.8816 26.8962 10.3444 27.3595 10.3444 27.9308C10.3443 28.5022 9.8816 28.9653 9.30973 28.9653Z"
          fill="#FFC565"
        />
        <Path
          d="M29.9994 7.24137C29.4276 7.24137 28.9648 6.77812 28.9648 6.20684V1.03453C28.9648 0.463242 29.4276 0 29.9994 0C30.5711 0 31.0339 0.463242 31.0339 1.03453V6.20695C31.0339 6.77824 30.5711 7.24137 29.9994 7.24137Z"
          fill="#FFC565"
        />
        <Path
          d="M30.0014 32.9092C29.3921 32.9092 28.8916 32.4278 28.8676 31.8191L28.429 20.6325C28.394 19.7415 29.107 19 29.9987 19H30.004C30.8957 19 31.6086 19.7414 31.5737 20.6325L31.135 31.8191C31.1112 32.4278 30.6106 32.9092 30.0014 32.9092Z"
          fill="#FEA711"
        />
        <Path
          d="M30.0007 37.0004C30.6785 37.0004 31.2279 36.4509 31.2279 35.7731C31.2279 35.0954 30.6785 34.5459 30.0007 34.5459C29.3229 34.5459 28.7734 35.0954 28.7734 35.7731C28.7734 36.4509 29.3229 37.0004 30.0007 37.0004Z"
          fill="#FEA711"
        />
        <Path
          d="M40.8601 10.1518C40.6843 10.1518 40.5066 10.1073 40.3439 10.0134C39.8489 9.7275 39.6791 9.09504 39.9651 8.60004L41.5167 5.91234C41.8027 5.41688 42.4359 5.24707 42.9301 5.53348C43.4251 5.81941 43.5949 6.45188 43.309 6.94688L41.7573 9.63457C41.5652 9.96633 41.2178 10.1518 40.8601 10.1518Z"
          fill="#FFF1D8"
        />
        <Path
          d="M17.5828 50.4667C17.407 50.4667 17.2292 50.4221 17.0666 50.3283C16.5716 50.0423 16.4018 49.4099 16.6877 48.9149L18.2394 46.2272C18.5253 45.7322 19.1578 45.5619 19.6528 45.8483C20.1478 46.1343 20.3176 46.7667 20.0317 47.2617L18.48 49.9494C18.2879 50.2814 17.9404 50.4667 17.5828 50.4667Z"
          fill="#FFF1D8"
        />
        <Path
          d="M19.1366 10.1518C18.7789 10.1518 18.4315 9.96645 18.2394 9.63457L16.6877 6.94688C16.4018 6.45188 16.5716 5.81941 17.0666 5.53348C17.5586 5.24707 18.193 5.41688 18.48 5.91234L20.0317 8.60004C20.3176 9.09504 20.1478 9.7275 19.6528 10.0134C19.4901 10.1073 19.3124 10.1518 19.1366 10.1518Z"
          fill="#FFF1D8"
        />
        <Path
          d="M42.4139 50.4667C42.0563 50.4667 41.7088 50.2813 41.5167 49.9494L39.9651 47.2617C39.6791 46.7667 39.8489 46.1343 40.3439 45.8483C40.8369 45.5619 41.4703 45.7322 41.7573 46.2272L43.309 48.9149C43.5949 49.4099 43.4251 50.0423 42.9301 50.3283C42.7675 50.4224 42.5896 50.4667 42.4139 50.4667Z"
          fill="#FFF1D8"
        />
        <Path
          d="M51.4985 41.3793C51.3227 41.3793 51.145 41.3347 50.9823 41.2409L48.2951 39.6892C47.8001 39.4032 47.6303 38.7704 47.9162 38.2758C48.2022 37.7797 48.8346 37.6116 49.3296 37.8969L52.0168 39.4486C52.5118 39.7345 52.6817 40.3673 52.3957 40.862C52.2036 41.1939 51.8561 41.3793 51.4985 41.3793Z"
          fill="#FFF1D8"
        />
        <Path
          d="M11.1841 18.1035C11.0083 18.1035 10.8305 18.0589 10.6679 17.9651L7.98064 16.4134C7.48564 16.1275 7.31583 15.4946 7.60177 15C7.88771 14.5045 8.52099 14.3347 9.01517 14.6211L11.7024 16.1728C12.1974 16.4587 12.3672 17.0916 12.0813 17.5862C11.8892 17.918 11.5417 18.1035 11.1841 18.1035Z"
          fill="#FFF1D8"
        />
        <Path
          d="M48.8134 18.1035C48.4558 18.1035 48.1083 17.9181 47.9162 17.5862C47.6303 17.0917 47.8001 16.4587 48.2951 16.1728L50.9823 14.6211C51.4753 14.3347 52.1087 14.5045 52.3957 15C52.6817 15.4945 52.5118 16.1275 52.0168 16.4134L49.3296 17.9651C49.167 18.0589 48.9891 18.1035 48.8134 18.1035Z"
          fill="#FFF1D8"
        />
        <Path
          d="M8.49896 41.3793C8.1413 41.3793 7.79384 41.1939 7.60177 40.862C7.31583 40.3675 7.48564 39.7345 7.98064 39.4486L10.6679 37.8969C11.1609 37.6116 11.7953 37.7797 12.0813 38.2758C12.3672 38.7703 12.1974 39.4032 11.7024 39.6892L9.01517 41.2409C8.85263 41.3348 8.67486 41.3793 8.49896 41.3793Z"
          fill="#FFF1D8"
        />
        <Path
          d="M33.104 56.8964H26.8971C25.7544 56.8964 24.8281 55.9701 24.8281 54.8275V49.655H35.173V54.8275C35.173 55.9701 34.2467 56.8964 33.104 56.8964Z"
          fill="#EBF1FD"
        />
        <Path
          d="M35.1723 51.7241H24.8275C24.2562 51.7241 23.793 51.2608 23.793 50.6896C23.793 50.1183 24.2562 49.655 24.8275 49.655H35.1723C35.7436 49.655 36.2069 50.1183 36.2069 50.6896C36.2069 51.261 35.7436 51.7241 35.1723 51.7241Z"
          fill="#D5E2F9"
        />
      </G>
      <Defs>
        <clipPath id="clip0_2417_32169">
          <Rect width="60" height="60" fill="white" />
        </clipPath>
      </Defs>
    </Svg>
  );
}